/*!
 * vue-stack v1.13.0 
 * (c) 2021 dadajam4
 * Released under the MIT License.
 */
import Vue from 'vue';

if (typeof document !== 'undefined' && !document.scrollingElement) {
  var judged = false;
  var element = null;

  var scrollingElement = function scrollingElement() {
    if (judged) return element;
    if (!document.documentElement) return element;

    if (document.body.scrollTop) {
      judged = true;
      return element = document.body;
    }

    var iframe = document.createElement('iframe');
    iframe.style.height = '1px';
    document.documentElement.appendChild(iframe);
    if (!iframe.contentWindow) return element;
    var doc = iframe.contentWindow.document;
    doc.write('<!DOCTYPE html><div style="height:9999em">x</div>');
    doc.close();
    if (!doc.documentElement) return element;
    var isCompliant = doc.documentElement.scrollHeight > doc.body.scrollHeight;
    iframe.parentNode.removeChild(iframe);
    judged = true;
    return element = isCompliant ? document.documentElement : document.body;
  };

  Object.defineProperty(document, 'scrollingElement', {
    get: scrollingElement
  });
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.

var reflectionIsSupported = typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;

function copyReflectionMetadata(to, from) {
  forwardMetadata(to, from);
  Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
    forwardMetadata(to.prototype, from.prototype, key);
  });
  Object.getOwnPropertyNames(from).forEach(function (key) {
    forwardMetadata(to, from, key);
  });
}

function forwardMetadata(to, from, propertyKey) {
  var metaKeys = propertyKey ? Reflect.getOwnMetadataKeys(from, propertyKey) : Reflect.getOwnMetadataKeys(from);
  metaKeys.forEach(function (metaKey) {
    var metadata = propertyKey ? Reflect.getOwnMetadata(metaKey, from, propertyKey) : Reflect.getOwnMetadata(metaKey, from);

    if (propertyKey) {
      Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
    } else {
      Reflect.defineMetadata(metaKey, metadata, to);
    }
  });
}

var fakeArray = {
  __proto__: []
};
var hasProto = fakeArray instanceof Array;

function createDecorator(factory) {
  return function (target, key, index) {
    var Ctor = typeof target === 'function' ? target : target.constructor;

    if (!Ctor.__decorators__) {
      Ctor.__decorators__ = [];
    }

    if (typeof index !== 'number') {
      index = undefined;
    }

    Ctor.__decorators__.push(function (options) {
      return factory(options, key, index);
    });
  };
}

function mixins() {
  var Ctors = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    Ctors[_i] = arguments[_i];
  }

  return Vue.extend({
    mixins: Ctors
  });
}

function isPrimitive(value) {
  var type = _typeof(value);

  return value == null || type !== 'object' && type !== 'function';
}

function warn(message) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-class-component] ' + message);
  }
}

function collectDataFromConstructor(vm, Component) {
  // override _init to prevent to init as Vue instance
  var originalInit = Component.prototype._init;

  Component.prototype._init = function () {
    var _this = this; // proxy to actual vm


    var keys = Object.getOwnPropertyNames(vm); // 2.2.0 compat (props are no longer exposed as self properties)

    if (vm.$options.props) {
      for (var key in vm.$options.props) {
        if (!vm.hasOwnProperty(key)) {
          keys.push(key);
        }
      }
    }

    keys.forEach(function (key) {
      if (key.charAt(0) !== '_') {
        Object.defineProperty(_this, key, {
          get: function get() {
            return vm[key];
          },
          set: function set(value) {
            vm[key] = value;
          },
          configurable: true
        });
      }
    });
  }; // should be acquired class property values


  var data = new Component(); // restore original _init to avoid memory leak (#209)

  Component.prototype._init = originalInit; // create plain data object

  var plainData = {};
  Object.keys(data).forEach(function (key) {
    if (data[key] !== undefined) {
      plainData[key] = data[key];
    }
  });

  if (process.env.NODE_ENV !== 'production') {
    if (!(Component.prototype instanceof Vue) && Object.keys(plainData).length > 0) {
      warn('Component class must inherit Vue or its descendant class ' + 'when class property is used.');
    }
  }

  return plainData;
}

var $internalHooks = ['data', 'beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeDestroy', 'destroyed', 'beforeUpdate', 'updated', 'activated', 'deactivated', 'render', 'errorCaptured', 'serverPrefetch' // 2.6
];

function componentFactory(Component, options) {
  if (options === void 0) {
    options = {};
  }

  options.name = options.name || Component._componentTag || Component.name; // prototype props.

  var proto = Component.prototype;
  Object.getOwnPropertyNames(proto).forEach(function (key) {
    if (key === 'constructor') {
      return;
    } // hooks


    if ($internalHooks.indexOf(key) > -1) {
      options[key] = proto[key];
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(proto, key);

    if (descriptor.value !== void 0) {
      // methods
      if (typeof descriptor.value === 'function') {
        (options.methods || (options.methods = {}))[key] = descriptor.value;
      } else {
        // typescript decorated data
        (options.mixins || (options.mixins = [])).push({
          data: function data() {
            var _a;

            return _a = {}, _a[key] = descriptor.value, _a;
          }
        });
      }
    } else if (descriptor.get || descriptor.set) {
      // computed properties
      (options.computed || (options.computed = {}))[key] = {
        get: descriptor.get,
        set: descriptor.set
      };
    }
  });
  (options.mixins || (options.mixins = [])).push({
    data: function data() {
      return collectDataFromConstructor(this, Component);
    }
  }); // decorate options

  var decorators = Component.__decorators__;

  if (decorators) {
    decorators.forEach(function (fn) {
      return fn(options);
    });
    delete Component.__decorators__;
  } // find super


  var superProto = Object.getPrototypeOf(Component.prototype);
  var Super = superProto instanceof Vue ? superProto.constructor : Vue;
  var Extended = Super.extend(options);
  forwardStaticMembers(Extended, Component, Super);

  if (reflectionIsSupported) {
    copyReflectionMetadata(Extended, Component);
  }

  return Extended;
}

var reservedPropertyNames = [// Unique id
'cid', // Super Vue constructor
'super', // Component options that will be used by the component
'options', 'superOptions', 'extendOptions', 'sealedOptions', // Private assets
'component', 'directive', 'filter'];
var shouldIgnore = {
  prototype: true,
  arguments: true,
  callee: true,
  caller: true
};

function forwardStaticMembers(Extended, Original, Super) {
  // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
  Object.getOwnPropertyNames(Original).forEach(function (key) {
    // Skip the properties that should not be overwritten
    if (shouldIgnore[key]) {
      return;
    } // Some browsers does not allow reconfigure built-in properties


    var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);

    if (extendedDescriptor && !extendedDescriptor.configurable) {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(Original, key); // If the user agent does not support `__proto__` or its family (IE <= 10),
    // the sub class properties may be inherited properties from the super class in TypeScript.
    // We need to exclude such properties to prevent to overwrite
    // the component options object which stored on the extended constructor (See #192).
    // If the value is a referenced value (object or function),
    // we can check equality of them and exclude it if they have the same reference.
    // If it is a primitive value, it will be forwarded for safety.

    if (!hasProto) {
      // Only `cid` is explicitly exluded from property forwarding
      // because we cannot detect whether it is a inherited property or not
      // on the no `__proto__` environment even though the property is reserved.
      if (key === 'cid') {
        return;
      }

      var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);

      if (!isPrimitive(descriptor.value) && superDescriptor && superDescriptor.value === descriptor.value) {
        return;
      }
    } // Warn if the users manually declare reserved properties


    if (process.env.NODE_ENV !== 'production' && reservedPropertyNames.indexOf(key) >= 0) {
      warn("Static property name '" + key + "' declared on class '" + Original.name + "' " + 'conflicts with reserved property name of Vue internal. ' + 'It may cause unexpected behavior of the component. Consider renaming the property.');
    }

    Object.defineProperty(Extended, key, descriptor);
  });
}

function Component(options) {
  if (typeof options === 'function') {
    return componentFactory(options);
  }

  return function (Component) {
    return componentFactory(Component, options);
  };
}

Component.registerHooks = function registerHooks(keys) {
  $internalHooks.push.apply($internalHooks, keys);
};

/** vue-property-decorator verson 8.1.1 MIT LICENSE copyright 2018 kaorun343 */
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */

var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';

function applyMetadata(options, target, key) {
  if (reflectMetadataIsSupported) {
    if (!Array.isArray(options) && typeof options !== 'function' && typeof options.type === 'undefined') {
      options.type = Reflect.getMetadata('design:type', target, key);
    }
  }
}
/**
 * decorator of model
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */


function Model(event, options) {
  if (options === void 0) {
    options = {};
  }

  return function (target, key) {
    applyMetadata(options, target, key);
    createDecorator(function (componentOptions, k) {
      (componentOptions.props || (componentOptions.props = {}))[k] = options;
      componentOptions.model = {
        prop: k,
        event: event || k
      };
    })(target, key);
  };
}
/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */

function Prop(options) {
  if (options === void 0) {
    options = {};
  }

  return function (target, key) {
    applyMetadata(options, target, key);
    createDecorator(function (componentOptions, k) {
      (componentOptions.props || (componentOptions.props = {}))[k] = options;
    })(target, key);
  };
}
/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */

function Watch(path, options) {
  if (options === void 0) {
    options = {};
  }

  var _a = options.deep,
      deep = _a === void 0 ? false : _a,
      _b = options.immediate,
      immediate = _b === void 0 ? false : _b;
  return createDecorator(function (componentOptions, handler) {
    if (_typeof(componentOptions.watch) !== 'object') {
      componentOptions.watch = Object.create(null);
    }

    var watch = componentOptions.watch;

    if (_typeof(watch[path]) === 'object' && !Array.isArray(watch[path])) {
      watch[path] = [watch[path]];
    } else if (typeof watch[path] === 'undefined') {
      watch[path] = [];
    }

    watch[path].push({
      handler: handler,
      deep: deep,
      immediate: immediate
    });
  });
} // Code copied from Vue/src/shared/util.js

var vueStackThemeNames = ['light', 'dark'];

var merge = function merge(target, source) {
  for (var _i = 0, _Object$keys = Object.keys(source); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    var sourceValue = source[key];
    if (sourceValue === undefined) continue;

    if (sourceValue instanceof Object && typeof sourceValue !== 'function') {
      target[key] = merge(target[key], sourceValue);
    } else {
      target[key] = sourceValue;
    } // if (key in target) {
    //   const sourceValue = source[key];
    //   if (sourceValue === undefined) continue;
    //   if (sourceValue instanceof Object && typeof sourceValue !== 'function') {
    //     target[key] = merge(target[key], sourceValue);
    //   } else {
    //     target[key] = sourceValue;
    //   }
    // }

  }

  return target;
};

var vueStackThemeSettingsDefaults = function vueStackThemeSettingsDefaults(source) {
  var settings = {
    defaultTheme: 'light',
    usePrefersColorScheme: true,
    useScrollStop: true,
    zIndex: 32767,
    ripple: true,
    themes: {
      light: {
        background: '#fff',
        text: 'rgba(0, 0, 0, 0.87)',
        caption: 'rgba(0, 0, 0, 0.87)',
        backdrop: 'rgba(33, 33, 33, 0.46)',
        contexts: {
          primary: {
            base: '#1976d2',
            text: '#fff'
          },
          secondary: {
            base: '#424242',
            text: '#fff'
          },
          gray: {
            base: '#616161',
            text: '#fff'
          },
          accent: {
            base: '#82b1ff',
            text: '#fff'
          },
          dark: {
            base: '#323232',
            text: '#fff'
          },
          error: {
            base: '#ff5252',
            text: '#fff'
          },
          info: {
            base: '#2196f3',
            text: '#fff'
          },
          success: {
            base: '#4caf50',
            text: '#fff'
          },
          warning: {
            base: '#ffc107',
            text: '#fff'
          },
          field: {
            base: '#fff',
            text: 'rgba(0, 0, 0, 0.87)'
          },
          muted: {
            base: 'rgba(0, 0, 0, 0.26)',
            text: 'rgba(0, 0, 0, 0.12)'
          }
        }
      },
      dark: {
        background: '#292a2d',
        text: '#e1e1e1',
        caption: '#a5a5a5',
        backdrop: 'rgba(33, 33, 33, 0.46)',
        contexts: {
          primary: {
            base: '#1976d2',
            text: '#fff'
          },
          secondary: {
            base: '#424242',
            text: '#fff'
          },
          gray: {
            base: '#616161',
            text: '#fff'
          },
          accent: {
            base: '#82b1ff',
            text: '#fff'
          },
          dark: {
            base: '#121212',
            text: '#fff'
          },
          error: {
            base: '#ff5252',
            text: '#fff'
          },
          info: {
            base: '#2196f3',
            text: '#fff'
          },
          success: {
            base: '#4caf50',
            text: '#fff'
          },
          warning: {
            base: '#ffc107',
            text: '#fff'
          },
          field: {
            base: '#202124',
            text: '#fff'
          },
          muted: {
            base: 'rgba(255, 255, 255, 0.26)',
            text: 'rgba(255, 255, 255, 0.12)'
          }
        }
      }
    },
    strings: {
      ok: 'OK',
      cancel: 'CANCEL',
      close: 'CLOSE'
    },
    snackbar: {
      color: 'dark'
    },
    dialog: {
      contentClass: 'v-stack-dynamic-dialog',
      transition: 'v-stack-slide-y',
      backdrop: true,
      closeOnEsc: true,
      persistent: false,
      navigationGuard: true,
      minWidth: 280,
      maxWidth: 540,
      header: ''
    },
    dialogActions: {
      cancel: {
        outline: true,
        color: 'primary'
      }
    }
  };
  return source ? merge(settings, source) : settings;
};

// https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
var _supportsPassive = false;

try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      _supportsPassive = true;
    }
  });
  window.addEventListener('test', null, opts);
  window.removeEventListener('test', null, opts);
} catch (e) {}

var SUPPORTS_PASSIVE = _supportsPassive;
function toNumber(value) {
  return typeof value === 'number' ? value : parseFloat(value);
}
function warn$1(message) {
  console.warn("[vue-stack] ".concat(message));
}
function error(message) {
  return new Error("[vue-stack] ".concat(message));
}
function pushVNodeEvent(data, event, cb) {
  data.on = data.on || {};
  data.on[event] = data.on[event] || [];
  if (!Array.isArray(data.on[event])) data.on[event] = [data.on[event]];
  data.on[event].push(cb);
}
function isFocusable(element) {
  if (element.tabIndex > 0 || element.tabIndex === 0 && element.getAttribute('tabIndex') !== null) {
    return true;
  }

  if (element.disabled) {
    return false;
  }

  switch (element.nodeName) {
    case 'A':
      return !!element.href && element.rel != 'ignore';

    case 'INPUT':
      return element.type != 'hidden' && element.type != 'file';

    case 'BUTTON':
    case 'SELECT':
    case 'TEXTAREA':
      return true;

    default:
      return false;
  }
}
function attemptFocus(element) {
  if (!isFocusable(element)) {
    return false;
  } // aria.Utils.IgnoreUtilFocusChanges = true;


  try {
    element.focus();
  } catch (e) {} // aria.Utils.IgnoreUtilFocusChanges = false;


  return document.activeElement === element;
}
function focusFirstDescendant(element) {
  for (var i = 0; i < element.childNodes.length; i++) {
    var child = element.childNodes[i];

    if (attemptFocus(child) || focusFirstDescendant(child)) {
      return true;
    }
  }

  return false;
}

var VStackContext =
/*#__PURE__*/
function (_Vue) {
  _inherits(VStackContext, _Vue);

  function VStackContext() {
    var _this;

    _classCallCheck(this, VStackContext);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VStackContext).apply(this, arguments));
    _this.uid = 0;
    _this.internalTheme = _this.$vstackSettings.defaultTheme;
    _this.stacks = [];
    _this.width = 0;
    _this.height = 0;
    _this.transitioningStackIds = [];
    _this.colorSchemeWatcherList = [];
    return _this;
  }

  _createClass(VStackContext, [{
    key: "createId",
    value: function createId() {
      var id = this.uid + 1;
      this.uid = id;
      return id;
    }
  }, {
    key: "add",
    value: function add(stack) {
      var index = -1;

      if (!this.stacks.includes(stack)) {
        stack.stackId = this.createId();
        index = this.stacks.push(stack);
      }

      return index;
    }
  }, {
    key: "remove",
    value: function remove(stack) {
      var index = this.stacks.indexOf(stack);
      return this.stacks.splice(index, 1);
    }
  }, {
    key: "getFront",
    value: function getFront() {
      var stacks = this.stacks.filter(function (stack) {
        return stack.isActive;
      });
      var length = stacks.length;
      if (length === 0) return;
      var maxVm = null;
      var maxActivateOrder = 0;
      stacks.forEach(function (stack) {
        var activateOrder = stack.activateOrder;

        if (activateOrder > maxActivateOrder) {
          maxActivateOrder = activateOrder;
          maxVm = stack;
        }
      });
      return maxVm;
    }
  }, {
    key: "setToFront",
    value: function setToFront(stack) {
      var front = this.getFront();
      var maxActivateOrder = front ? front.activateOrder : 0;
      stack.activateOrder = maxActivateOrder + 1;
    }
  }, {
    key: "isFront",
    value: function isFront(stack) {
      var frontStack = this.getFront();
      return !!frontStack && frontStack.stackIs(stack);
    }
  }, {
    key: "addTransitioningStack",
    value: function addTransitioningStack(stackOrId) {
      var id = typeof stackOrId === 'number' ? stackOrId : stackOrId.stackId;

      if (!this.transitioningStackIds.includes(id)) {
        this.transitioningStackIds.push(id);
      }
    }
  }, {
    key: "removeTransitioningStack",
    value: function removeTransitioningStack(stackOrId) {
      var id = typeof stackOrId === 'number' ? stackOrId : stackOrId.stackId;
      var index = this.transitioningStackIds.indexOf(id);

      if (index !== -1) {
        this.transitioningStackIds.splice(index, 1);
      }
    }
  }, {
    key: "getString",
    value: function getString(key) {
      var string = this.$vstackSettings.strings[key];
      return typeof string === 'function' ? string(this) : string;
    }
  }, {
    key: "updateContainerRect",
    value: function updateContainerRect() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    }
  }, {
    key: "dynamic",
    value: function dynamic(setting) {
      var dynamicContainer = this.dynamicContainer;

      if (!dynamicContainer) {
        console.warn(setting);
        throw error('You need an instance of VStackDynamicContainer.');
      }

      return dynamicContainer.push(setting);
    }
  }, {
    key: "snackbar",
    value: function snackbar(contentOrSettings) {
      var _settings = _typeof(contentOrSettings) === 'object' ? contentOrSettings : {
        content: contentOrSettings
      };

      var settings = _objectSpread({}, this.$vstackSettings.snackbar, _settings);

      var content = settings.content;

      var props = _objectSpread({}, settings);

      delete props.content;
      return this.dynamic({
        Ctor: VStackSnackbar$1,
        data: {
          props: props
        },
        children: content
      });
    }
  }, {
    key: "dialog",
    value: function dialog(opts) {
      var _this$$vstackSettings = _objectSpread({}, this.$vstackSettings.dialog, opts),
          contentClass = _this$$vstackSettings.contentClass,
          transition = _this$$vstackSettings.transition,
          backdrop = _this$$vstackSettings.backdrop,
          closeOnEsc = _this$$vstackSettings.closeOnEsc,
          persistent = _this$$vstackSettings.persistent,
          navigationGuard = _this$$vstackSettings.navigationGuard,
          minWidth = _this$$vstackSettings.minWidth,
          maxWidth = _this$$vstackSettings.maxWidth,
          theme = _this$$vstackSettings.theme,
          header = _this$$vstackSettings.header,
          prompt = _this$$vstackSettings.prompt;

      return this.dynamic({
        Ctor: VStackDialog$1,
        data: {
          props: {
            contentClass: contentClass,
            dialogType: opts.dialogType,
            header: header,
            actions: opts.actions,
            transition: transition,
            backdrop: backdrop,
            closeOnEsc: closeOnEsc,
            persistent: persistent,
            navigationGuard: navigationGuard,
            width: opts.width,
            minWidth: minWidth,
            maxWidth: maxWidth,
            theme: theme,
            prompt: prompt
          }
        },
        children: opts.content
      });
    }
  }, {
    key: "alert",
    value: function alert(opts) {
      var content = typeof opts === 'string' ? opts : opts.content;
      opts = _objectSpread({}, typeof opts === 'string' ? undefined : opts, {
        content: content
      });

      if (opts.dialogType == null) {
        opts.dialogType = 'alert';
      }

      opts.actions = opts.actions || [{
        type: 'ok',
        text: this.getString('ok'),
        autofocus: true,
        spacer: true,
        click: function click(dialog) {
          dialog.resolve(true);
        }
      }];
      return this.dialog(opts);
    }
  }, {
    key: "confirm",
    value: function confirm(opts) {
      var content = typeof opts === 'string' ? opts : opts.content;
      opts = _objectSpread({}, typeof opts === 'string' ? undefined : opts, {
        content: content
      });
      var _opts = opts,
          _opts$autofocus = _opts.autofocus,
          autofocus = _opts$autofocus === void 0 ? 'ok' : _opts$autofocus,
          prompt = _opts.prompt;

      if (opts.dialogType == null) {
        opts.dialogType = 'confirm';
      }

      opts.actions = opts.actions || [_objectSpread({
        type: 'cancel'
      }, this.$vstackSettings.dialogActions.cancel, {
        text: this.getString('cancel'),
        spacer: true,
        autofocus: autofocus === 'cancel',
        click: function click(dialog) {
          dialog.resolve(false);
        }
      }), {
        type: 'ok',
        text: this.getString('ok'),
        autofocus: autofocus === 'ok',
        click: function click(dialog) {
          if (prompt) {
            var promptInput = dialog.$refs.promptInput;
            var value = promptInput && promptInput.value;
            dialog.resolve(value);
          } else {
            dialog.resolve(true);
          }
        }
      }];
      return this.dialog(opts);
    }
  }, {
    key: "prompt",
    value: function prompt(opts) {
      opts = _objectSpread({}, typeof opts === 'string' ? {
        content: opts
      } : opts);
      var _opts2 = opts,
          prompt = _opts2.prompt;
      return this.confirm(_objectSpread({}, opts, {
        prompt: prompt || 'text',
        autofocus: false,
        content: opts.content || [this.$createElement('div', {
          staticClass: 'v-stack-prompt-activator'
        })]
      }));
    }
  }, {
    key: "getThemeContextColor",
    value: function getThemeContextColor(key) {
      var theme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.theme;
      var colorMap = this.$vstackSettings.themes[theme].contexts[key];

      if (!colorMap && this.computedTheme !== this.$vstackSettings.defaultTheme) {
        colorMap = this.$vstackSettings.themes[this.$vstackSettings.defaultTheme].contexts[key];

        if (!colorMap) {
          warn$1("missing context color at ".concat(key));
          colorMap = {
            base: '',
            text: ''
          };
        }
      }

      return colorMap;
    }
  }, {
    key: "render",
    value: function render(h) {
      var stacks = this.stacks;
      return h('div', {
        staticClass: 'v-stack-context',
        style: this.themeStyles
      }, [h(VStackContainer$1, {
        props: {
          stacks: stacks
        },
        ref: 'container'
      }), h(VStackDynamicContainer$1, {
        ref: 'dynamicContainer'
      })]);
    }
  }, {
    key: "keyDownHandler",
    value: function keyDownHandler(e) {
      if (e.defaultPrevented) return;

      if (e.which === 27) {
        var frontStack = this.getFront();
        frontStack && frontStack.onEsc(e);
      }
    }
  }, {
    key: "startWatchColorScheme",
    value: function startWatchColorScheme() {
      var _this2 = this;

      if (!this.$vstackSettings.usePrefersColorScheme) return;
      this.stopWatchColorScheme();
      vueStackThemeNames.forEach(function (name) {
        var list = window.matchMedia("(prefers-color-scheme: ".concat(name, ")"));

        if (list.matches) {
          _this2.theme = name;
        }

        var handler = function handler(ev) {
          if (ev.matches) {
            _this2.theme = name;
          }
        };

        list.addListener(handler);

        _this2.colorSchemeWatcherList.push({
          list: list,
          handler: handler
        });
      });
    }
  }, {
    key: "stopWatchColorScheme",
    value: function stopWatchColorScheme() {
      this.colorSchemeWatcherList.forEach(function (row) {
        row.list.removeListener(row.handler);
      });
      this.colorSchemeWatcherList = [];
    }
  }, {
    key: "created",
    value: function created() {
      var _this3 = this;

      if (this.$vstack) {
        this.$vstack.$destroy();
      }

      Object.defineProperty(Vue.prototype, '$vstack', {
        enumerable: true,
        configurable: true,
        get: function get() {
          return _this3;
        }
      });
      Vue.prototype.$snackbar = this.snackbar;
      Vue.prototype.$dialog = this.dialog;
      Vue.prototype.$alert = this.alert;
      Vue.prototype.$confirm = this.confirm;
      Vue.prototype.$prompt = this.prompt;

      if (typeof window !== 'undefined') {
        this.updateContainerRect();
        window.addEventListener('load', this.updateContainerRect, false);
        window.addEventListener('resize', this.updateContainerRect, false);
        document.addEventListener('keydown', this.keyDownHandler, false);
        this.startWatchColorScheme();
      }
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      if (typeof window !== 'undefined') {
        window.removeEventListener('load', this.updateContainerRect, false);
        window.removeEventListener('resize', this.updateContainerRect, false);
        document.removeEventListener('keydown', this.keyDownHandler, false);
        this.stopWatchColorScheme();
      }
    }
  }, {
    key: "theme",
    get: function get() {
      return this.internalTheme;
    },
    set: function set(theme) {
      if (this.internalTheme !== theme) {
        this.internalTheme = theme;
      }
    }
  }, {
    key: "computedTheme",
    get: function get() {
      return this.theme;
    }
  }, {
    key: "zIndex",
    get: function get() {
      return this.$vstackSettings.zIndex;
    }
  }, {
    key: "container",
    get: function get() {
      return this.$refs.container;
    }
  }, {
    key: "dynamicContainer",
    get: function get() {
      return this.$refs.dynamicContainer;
    }
  }, {
    key: "hasAnyTransitioningStack",
    get: function get() {
      return this.transitioningStackIds.length > 0;
    }
  }, {
    key: "themeSettings",
    get: function get() {
      return this.$vstackSettings.themes[this.computedTheme];
    }
  }, {
    key: "themeBackgroundColor",
    get: function get() {
      return this.themeSettings.background;
    }
  }, {
    key: "themeTextColor",
    get: function get() {
      return this.themeSettings.text;
    }
  }, {
    key: "themeStyles",
    get: function get() {
      return {
        backgroundColor: this.themeBackgroundColor,
        color: this.themeTextColor
      };
    }
  }, {
    key: "themeCaptionColor",
    get: function get() {
      return this.themeSettings.text;
    }
  }, {
    key: "themeBackdropColor",
    get: function get() {
      return this.themeSettings.backdrop;
    }
  }]);

  return VStackContext;
}(Vue);

VStackContext = __decorate([Component({
  name: 'v-stack-context',
  provide: function provide() {
    return {
      stackContext: this
    };
  }
})], VStackContext);
var VStackContext$1 = VStackContext;

var VStackContainer =
/*#__PURE__*/
function (_Vue) {
  _inherits(VStackContainer, _Vue);

  function VStackContainer() {
    _classCallCheck(this, VStackContainer);

    return _possibleConstructorReturn(this, _getPrototypeOf(VStackContainer).apply(this, arguments));
  }

  _createClass(VStackContainer, [{
    key: "render",
    value: function render(h) {
      return h('div', {
        attrs: {
          'v-stack-container': ''
        }
      });
    }
  }]);

  return VStackContainer;
}(Vue);

VStackContainer = __decorate([Component({
  name: 'v-stack-container'
})], VStackContainer);
var VStackContainer$1 = VStackContainer;

function closeConditional() {
  return false;
}

function directive(e, el, binding) {
  // Args may not always be supplied
  binding.args = binding.args || {}; // If no closeConditional was supplied assign a default

  var isActive = binding.args.closeConditional || closeConditional; // The include element callbacks below can be expensive
  // so we should avoid calling them when we're not active.
  // Explicitly check for false to allow fallback compatibility
  // with non-toggleable components

  if (!e || isActive(e) === false) return; // If click was triggered programmaticaly (domEl.click()) then
  // it shouldn't be treated as click-outside
  // Chrome/Firefox support isTrusted property
  // IE/Edge support pointerType property (empty if not triggered
  // by pointing device)

  if ('isTrusted' in e && !e.isTrusted || 'pointerType' in e && !e.pointerType) return; // Check if additional elements were passed to be included in check
  // (click must be outside all included elements, if any)

  var elements = (binding.args.include || function () {
    return [];
  })(); // Add the root element for the component this directive was defined on


  elements.push(el); // Check if it's a click outside our elements, and then if our callback returns true.
  // Non-toggleable components should take action in their callback and return falsy.
  // Toggleable can return true if it wants to deactivate.
  // Note that, because we're in the capture phase, this callback will occur before
  // the bubbling click event on any outside elements.

  !elements.some(function (el) {
    return el.contains(e.target);
  }) && setTimeout(function () {
    isActive(e) && binding.value && binding.value(e);
  }, 0);
}

var clickOutside = {
  // [data-app] may not be found
  // if using bind, inserted makes
  // sure that the root element is
  // available, iOS does not support
  // clicks on body
  inserted: function inserted(el, binding) {
    var onClick = function onClick(e) {
      return directive(e, el, binding);
    }; // iOS does not recognize click events on document
    // or body, this is the entire purpose of the v-app
    // component and [data-app], stop removing this
    // const app = document.querySelector('[data-app]') || document.body; // This is only for unit tests


    document.addEventListener('click', onClick, true);
    el._clickOutside = onClick;
  },
  unbind: function unbind(el) {
    if (!el._clickOutside) return; // const app = document.querySelector('[data-app]') || document.body; // This is only for unit tests

    document.removeEventListener('click', el._clickOutside, true);
    delete el._clickOutside;
  }
};

var getElementByActivateSource = function getElementByActivateSource(source) {
  if (!source) return;
  if (source instanceof HTMLElement) return source;
  if (source instanceof Event) source = source.target;
  if (source && source instanceof HTMLElement) return source;
};

var VStack =
/*#__PURE__*/
function (_Vue) {
  _inherits(VStack, _Vue);

  function VStack() {
    var _this;

    _classCallCheck(this, VStack);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VStack).apply(this, arguments));
    _this.needRender = false;
    _this.innerActive = _this.active;
    _this.stackId = null;
    _this.lastActivatorElement = null;
    _this.delayTimers = [];
    _this.internalCloseState = 'indeterminate';
    _this.internalMounted = false;
    _this.initialValue = _this.value || null;
    _this.internalValue = _this.value || null;
    _this.hasDetached = false;
    _this.stackIsDestroyed = false;
    _this.stackTimeoutId = null;
    _this.nowShowing = false;
    _this.nowClosing = false;
    _this.activateOrder = 0;
    _this.isBooted = false;
    _this.outsideClickAnimating = false;
    _this.outsideClickAnimateTimerId = null;
    return _this;
  }

  _createClass(VStack, [{
    key: "setToFront",
    value: function setToFront() {
      this.$vstack.setToFront(this);
    }
  }, {
    key: "stackIs",
    value: function stackIs(stack) {
      return this.stackId === stack.stackId;
    }
  }, {
    key: "setIsActive",
    value: function setIsActive(active) {
      var withEmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (active) this.isBooted = true;

      if (this.innerActive !== active) {
        this.clearStackTimeoutId();
        if (active) this.triggerContentReadyTick();
        this.innerActive = active;
        withEmit && this.$emit('change', active);

        if (active) {
          this.nowShowing = true;
          this.setToFront();
          this.$emit('show', this);
        } else {
          this.nowClosing = true;
          this.$emit('close', this);
        }
      }
    }
  }, {
    key: "onEsc",
    value: function onEsc(event) {
      this.closeOnEsc && this.cancel(false);
    }
  }, {
    key: "clearStackTimeoutId",
    value: function clearStackTimeoutId() {
      if (this.stackTimeoutId !== null) {
        clearTimeout(this.stackTimeoutId);
        this.stackTimeoutId = null;
      }
    }
  }, {
    key: "clearDelay",
    value: function clearDelay() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.delayTimers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var timer = _step.value;
          clearTimeout(timer);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.delayTimers = [];
    }
  }, {
    key: "runDelay",
    value: function runDelay(prop, cb) {
      this.clearDelay();
      var ammount = typeof prop === 'number' ? prop : this[prop];
      if (!ammount) return cb();
      this.delayTimers.push(setTimeout(cb, toNumber(ammount)));
    }
  }, {
    key: "onChangeHasContentHandler",
    value: function onChangeHasContentHandler() {
      this.initDetach();
    }
  }, {
    key: "onChangeInnerActive",
    value: function onChangeInnerActive(active) {
      if (active) {
        this.setNeedRender(true);
      }

      this.checkFocusTrap();
    }
  }, {
    key: "checkFocusTrap",
    value: function checkFocusTrap() {
      if (this.$isServer) return;

      if (this.isActive && this.focusTrap) {
        this.setupFocusTrapper();
      } else {
        this.removeFocusTrapper();
      }
    }
  }, {
    key: "trapFocus",
    value: function trapFocus(ev) {
      var content = this.$refs.content;
      if (!content) return;

      if (content.contains(ev.target)) {
        return;
      }

      for (var i = 0; i < content.childNodes.length; i++) {
        var child = content.childNodes[i];

        if (attemptFocus(child) || focusFirstDescendant(child)) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "setupFocusTrapper",
    value: function setupFocusTrapper() {
      var _this2 = this;

      this.removeFocusTrapper();

      this._focusTrapper = function (ev) {
        if (_this2.$vstack.isFront(_this2)) {
          _this2.trapFocus(ev);
        }
      };

      document.addEventListener('focus', this._focusTrapper, true);
    }
  }, {
    key: "removeFocusTrapper",
    value: function removeFocusTrapper() {
      if (this._focusTrapper) {
        document.removeEventListener('focus', this._focusTrapper, true);
        delete this._focusTrapper;
      }
    }
  }, {
    key: "onChangeActiveHandler",
    value: function onChangeActiveHandler(active) {
      this.setIsActive(active, false);
    }
  }, {
    key: "onChangeValueHandler",
    value: function onChangeValueHandler() {
      this.internalValue = this.value || null;
      this.initialValue = this.internalValue;
    }
  }, {
    key: "onRouteChangeHandler",
    value: function onRouteChangeHandler() {
      this.closeOnNavigation && this.close();
    }
  }, {
    key: "resetValue",
    value: function resetValue() {
      this.payload = this.initialValue;
    }
  }, {
    key: "setNeedRender",
    value: function setNeedRender(needRender) {
      if (!needRender) this.activateOrder = 0;
      this.needRender = this.alwaysRender || needRender;
    }
  }, {
    key: "onContentReady",
    value: function onContentReady() {}
  }, {
    key: "autofocus",
    value: function autofocus() {
      var content = this.$refs.content;
      if (!content) return;
      var target = content.querySelector('[autofocus]');

      if (target) {
        try {
          if (typeof target.focus === 'function') {
            target.focus();
          }
        } catch (err) {}
      }
    }
  }, {
    key: "triggerContentReadyTick",
    value: function triggerContentReadyTick() {
      var _this3 = this;

      var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var content = this.$refs.content;

      if (content && this.hasDetached) {
        this.autofocus();
        this.onContentReady();
        return;
      }

      count++;

      if (count < 3) {
        this.$nextTick(function () {
          _this3.triggerContentReadyTick(count);
        });
      }
    }
  }, {
    key: "setActivator",
    value: function setActivator(activator) {
      this.lastActivatorElement = activator || null;
    }
  }, {
    key: "show",
    value: function show(activateSource) {
      var _this4 = this;

      this.setActivator(activateSource && getElementByActivateSource(activateSource) || undefined); // Fix for bubbling cue.

      setTimeout(function () {
        _this4.isActive = true;
      }, 0);
    }
  }, {
    key: "close",
    value: function close() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _opts$force = opts.force,
          force = _opts$force === void 0 ? false : _opts$force,
          _opts$state = opts.state,
          state = _opts$state === void 0 ? 'indeterminate' : _opts$state;
      if (!force && this.persistent) return;
      this.internalCloseState = state;
      this.isActive = false;
    }
  }, {
    key: "resolve",
    value: function resolve(payload) {
      if (payload !== undefined) {
        this.payload = payload;
      }

      return this.close({
        force: true,
        state: 'resolve'
      });
    }
  }, {
    key: "cancel",
    value: function cancel(force) {
      return this.close({
        force: force,
        state: 'cancel'
      });
    }
  }, {
    key: "toggle",
    value: function toggle(activateSource) {
      return this.isActive ? this.close() : this.show(activateSource);
    }
  }, {
    key: "created",
    value: function created() {
      this.$vstack.add(this);
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      try {
        var _this$$refs = this.$refs,
            content = _this$$refs.content,
            backdrop = _this$$refs.backdrop;

        if (content) {
          var parentNode = content.parentNode;

          if (parentNode) {
            parentNode.removeChild(content);
            parentNode.removeChild(backdrop);
          }
        }

        var activatorNode = this.activatorNode;

        if (activatorNode) {
          var elm = activatorNode.elm;

          if (elm) {
            var _parentNode = elm.parentNode;

            if (_parentNode) {
              _parentNode.removeChild(elm);
            }
          }
        }
      } catch (e) {}

      this.removeFocusTrapper();
      this.clearStackTimeoutId();
      this.stackIsDestroyed = true;
      this.clearNavigationGuard();
      this.$vstack.remove(this);
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var defaultSlot = this.$scopedSlots.default;
      return {
        tag: 'div',
        children: defaultSlot && defaultSlot(this)
      };
    }
  }, {
    key: "mouseEnterHandler",
    value: function mouseEnterHandler(e) {
      var _this5 = this;

      if (this.nowTransitioning) return;
      this.clearDelay();
      !this.isActive && this.runDelay('openDelay', function () {
        !_this5.isActive && _this5.show(e);
      });
    }
  }, {
    key: "mouseLeaveHandler",
    value: function mouseLeaveHandler(e) {
      var _this6 = this;

      this.clearDelay();
      this.isActive && this.runDelay('closeDelay', function () {
        if (_this6.$refs.content && (e.relatedTarget === _this6.$refs.content || _this6.$refs.content.contains(e.relatedTarget)) || _this6.$activator && (e.relatedTarget === _this6.$activator || _this6.$activator.contains(e.relatedTarget))) return;
        _this6.isActive && _this6.close();
      });
    }
  }, {
    key: "clearNavigationGuard",
    value: function clearNavigationGuard() {
      this._navigationGuardRemover && this._navigationGuardRemover();
      delete this._navigationGuardRemover;
    }
  }, {
    key: "onChangeAlwaysRenderHandler",
    value: function onChangeAlwaysRenderHandler(alwaysRender) {
      if (alwaysRender) {
        this.isBooted = true;
        this.setNeedRender(true);
      }
    }
  }, {
    key: "onChangeNavigationGuardHandler",
    value: function onChangeNavigationGuardHandler() {
      var _this7 = this;

      var $router = this.$router;
      if (!$router) return;
      var navigationGuard = this.navigationGuard;
      this.clearNavigationGuard();
      if (!navigationGuard) return;
      var guard = typeof navigationGuard === 'function' ? navigationGuard : function (to, from, next) {
        _this7.isActive ? next(false) : next();
      };
      $router.beforeEach(guard);
    }
  }, {
    key: "initDetach",
    value: function initDetach() {
      var _this8 = this;

      this.$nextTick(function () {
        var _this8$$refs = _this8.$refs,
            content = _this8$$refs.content,
            backdrop = _this8$$refs.backdrop;
        if (_this8.stackIsDestroyed || _this8.hasDetached || !content) return;
        var target = document.querySelector('[v-stack-container]') || document.body;
        target.insertBefore(content, target.firstChild);

        if (backdrop) {
          target.insertBefore(backdrop, target.firstChild);
        }

        _this8.hasDetached = true;
      });
    }
  }, {
    key: "beforeMount",
    value: function beforeMount() {
      var _this9 = this;

      this.$nextTick(function () {
        var activatorNode = _this9.activatorNode;

        if (activatorNode) {
          var parentNode = _this9.$el.parentNode;

          if (parentNode) {
            var elm = activatorNode.elm;
            elm && parentNode.insertBefore(elm, _this9.$el);
          }
        }
      });
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.internalMounted = true;
      this.initDetach();

      if (this.isActive) {
        this.setToFront();
        this.triggerContentReadyTick();
        this.checkFocusTrap();
      }
    }
  }, {
    key: "deactivated",
    value: function deactivated() {
      this.isActive = false;
    }
  }, {
    key: "isFrontStack",
    value: function isFrontStack() {
      return this.$vstack.isFront(this);
    }
  }, {
    key: "genActivator",
    value: function genActivator() {
      var _this10 = this;

      var activatorSlot = this.$scopedSlots.activator;
      if (!activatorSlot) return;
      var activators = activatorSlot(this);
      var activator = activators && activators[0];
      if (!activator) return;
      activator.data = activator.data || {};
      var data = activator.data;
      var primaryTrigger = this.openOnContextmenu ? 'contextmenu' : 'click';
      pushVNodeEvent(data, primaryTrigger, function (e) {
        if (e.defaultPrevented) return;
        _this10.openOnContextmenu && e.preventDefault();

        _this10.toggle(e);
      });

      if (this.openOnHover) {
        pushVNodeEvent(data, 'mouseenter', this.mouseEnterHandler);
        pushVNodeEvent(data, 'mouseleave', this.mouseLeaveHandler);
      }

      return activator;
    }
  }, {
    key: "genBackdrop",
    value: function genBackdrop() {
      var backdrop = this.backdrop,
          h = this.$createElement;
      if (!backdrop) return;
      var $backdrop = h('div', {
        staticClass: 'v-stack-backdrop',
        style: {
          zIndex: this.computedZIndex,
          backgroundColor: this.$vstack.themeBackdropColor
        },
        directives: [{
          name: 'show',
          value: this.isActive
        }],
        ref: 'backdrop',
        key: "".concat(this.stackId, "-backdrop")
      });
      return h('transition', {
        props: {
          name: 'v-stack-fade'
        }
      }, [$backdrop]);
    }
  }, {
    key: "animateByOutsideClick",
    value: function animateByOutsideClick() {
      var _this11 = this;

      this.outsideClickAnimating = false;
      this.$nextTick(function () {
        _this11.outsideClickAnimating = true;

        if (_this11.outsideClickAnimateTimerId !== null) {
          clearTimeout(_this11.outsideClickAnimateTimerId);
        }

        _this11.outsideClickAnimateTimerId = window.setTimeout(function () {
          return _this11.outsideClickAnimating = false;
        }, 150);
      });
    }
  }, {
    key: "closeConditional",
    value: function closeConditional(e) {
      if (this.nowShowing || !this.isFrontStack() || this.$vstack.hasAnyTransitioningStack) {
        return false;
      }

      if (this.persistent) {
        if (!this.noClickAnimation && e.target === this.$refs.backdrop) {
          this.animateByOutsideClick();
        }

        return false;
      }

      return this.isActive;
    }
  }, {
    key: "genContent",
    value: function genContent() {
      var _this12 = this;

      var needRender = this.needRender,
          $scopedSlots = this.$scopedSlots,
          hasContent = this.hasContent,
          h = this.$createElement;
      var defaultSlot = $scopedSlots.default;
      if (!needRender || !hasContent || !defaultSlot) return;
      var info = this.renderContent(h);
      if (!info) return;
      var tag = info.tag,
          data = info.data,
          children = info.children;
      data = data || {};
      data.attrs = _objectSpread({}, this.$attrs, data.attrs);
      data.attrs['v-stack'] = this.stackId;

      if (this.outsideClickAnimating) {
        data.attrs['v-stack--outside-click-animate'] = '';
      }

      var contentClass = this.contentClass,
          contentStyle = this.contentStyle;

      if (contentClass) {
        data.class = data.class || [];
        if (!Array.isArray(data.class)) data.class = [data.class];
        if (!Array.isArray(contentClass)) contentClass = [contentClass];
        data.class = [].concat(_toConsumableArray(data.class), _toConsumableArray(contentClass));
      }

      data.style = data.style || [];
      if (!Array.isArray(data.style)) data.style = [data.style];
      data.style.push({
        zIndex: this.computedZIndex
      });

      if (contentStyle) {
        if (!Array.isArray(contentStyle)) contentStyle = [contentStyle];
        data.style = data.style.concat(contentStyle);
      }

      data.key = this.stackId;
      data.directives = data.directives || [];
      data.directives.push({
        name: 'show',
        value: this.isActive
      });

      if (this.closeOnClick) {
        data.directives.push({
          name: 'click-outside',
          value: function value() {
            _this12.close();
          },
          args: {
            closeConditional: this.closeConditional
          }
        });
      }

      if (this.openOnHover) {
        pushVNodeEvent(data, 'mouseenter', this.mouseEnterHandler);
        pushVNodeEvent(data, 'mouseleave', this.mouseLeaveHandler);
      }

      data.on = data.on || {};
      data.on.click = data.on.click || [];
      if (!Array.isArray(data.on.click)) data.on.click = [data.on.click];
      data.on.click.push(function (e) {
        e.stopPropagation();
      });
      data.ref = 'content';
      return h(tag, data, children);
    }
  }, {
    key: "render",
    value: function render(h) {
      var _this13 = this;

      var children = [];
      var activator = this.genActivator();
      var backdrop = this.genBackdrop();
      var content = this.genContent();

      if (activator) {
        children.push(activator);
        this.activatorNode = activator;
      } else {
        delete this.activatorNode;
      }

      if (backdrop) children.push(backdrop);
      var computedTransition = this.computedTransition;
      var transitionChildren = content ? [content] : undefined;
      var transitionListeners = {
        beforeEnter: function beforeEnter(el) {
          _this13.$vstack.addTransitioningStack(_this13);

          _this13.$emit('beforeEnter', _this13, el);
        },
        afterEnter: function afterEnter(el) {
          _this13.nowShowing = false;
          _this13.nowClosing = false;

          _this13.$vstack.removeTransitioningStack(_this13);

          _this13.clearStackTimeoutId();

          if (_this13.computedTimeout) {
            _this13.stackTimeoutId = window.setTimeout(function () {
              _this13.clearStackTimeoutId();

              _this13.close({
                force: true
              });
            }, _this13.computedTimeout);
          }

          _this13.$emit('afterEnter', _this13, el);
        },
        enterCancelled: function enterCancelled(el) {
          _this13.nowShowing = false;
          _this13.nowClosing = false;

          _this13.$vstack.removeTransitioningStack(_this13);
        },
        beforeLeave: function beforeLeave(el) {
          _this13.$vstack.addTransitioningStack(_this13);

          _this13.$emit('beforeLeave', _this13, el);
        },
        afterLeave: function afterLeave(el) {
          _this13.nowShowing = false;
          _this13.nowClosing = false;

          _this13.setNeedRender(false);

          _this13.$vstack.removeTransitioningStack(_this13);

          _this13.$emit('afterLeave', _this13, el);
        },
        leaveCancelled: function leaveCancelled(el) {
          _this13.nowShowing = false;
          _this13.nowClosing = false;

          _this13.$vstack.removeTransitioningStack(_this13);
        }
      };
      var transition = typeof computedTransition === 'string' ? h('transition', {
        props: {
          name: computedTransition
        },
        on: transitionListeners
      }, transitionChildren) : h(computedTransition, {
        props: this.transitionProps,
        on: transitionListeners
      }, transitionChildren);
      children.push(transition);
      return h('div', {
        attrs: {
          'v-stack-flagment': ''
        },
        staticStyle: {
          display: 'none'
        }
      }, children);
    }
  }, {
    key: "computedTimeout",
    get: function get() {
      var timeout = this.timeout;
      if (!timeout) return;
      return toNumber(timeout);
    }
  }, {
    key: "transitionProps",
    get: function get() {
      return undefined;
    }
  }, {
    key: "isMounted",
    get: function get() {
      return this.internalMounted;
    }
  }, {
    key: "hasContent",
    get: function get() {
      return this.isMounted && this.isBooted;
    }
  }, {
    key: "nowTransitioning",
    get: function get() {
      return this.nowShowing || this.nowClosing;
    }
  }, {
    key: "computedTransition",
    get: function get() {
      return this.transition;
    }
  }, {
    key: "closeState",
    get: function get() {
      return this.internalCloseState;
    }
  }, {
    key: "isResolved",
    get: function get() {
      return this.closeState === 'resolve';
    }
  }, {
    key: "isCanceled",
    get: function get() {
      return this.closeState === 'cancel';
    }
  }, {
    key: "payload",
    get: function get() {
      return this.isResolved ? this.internalValue : undefined;
    },
    set: function set(payload) {
      if (this.internalValue !== payload) {
        this.internalValue = payload;
        this.$emit('payload', payload);
      }
    }
  }, {
    key: "computedZIndex",
    get: function get() {
      var zIndex = this.zIndex;
      if (typeof zIndex === 'string') return parseInt(zIndex, 10);
      if (typeof zIndex === 'number') return zIndex;
      return this.$vstack.zIndex + this.activateOrder;
    }
  }, {
    key: "$activator",
    get: function get() {
      return this.lastActivatorElement;
    }
  }, {
    key: "isActive",
    get: function get() {
      return this.innerActive;
    },
    set: function set(active) {
      this.setIsActive(active);
    }
  }]);

  return VStack;
}(Vue);

__decorate([Model('change', {
  type: Boolean,
  default: false
})], VStack.prototype, "active", void 0);

__decorate([Prop({
  type: [String, Object],
  default: 'v-stack-fade'
})], VStack.prototype, "transition", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], VStack.prototype, "alwaysRender", void 0);

__decorate([Prop({
  type: [Boolean, String]
})], VStack.prototype, "backdrop", void 0);

__decorate([Prop({
  type: Boolean
})], VStack.prototype, "openOnHover", void 0);

__decorate([Prop({
  type: Boolean
})], VStack.prototype, "openOnContextmenu", void 0);

__decorate([Prop({
  type: [String, Number],
  default: 0
})], VStack.prototype, "openDelay", void 0);

__decorate([Prop({
  type: [String, Number],
  default: 200
})], VStack.prototype, "closeDelay", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], VStack.prototype, "closeOnClick", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], VStack.prototype, "closeOnEsc", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], VStack.prototype, "closeOnNavigation", void 0);

__decorate([Prop({
  type: Boolean
})], VStack.prototype, "persistent", void 0);

__decorate([Prop({
  type: [String, Number]
})], VStack.prototype, "timeout", void 0);

__decorate([Prop({
  type: Boolean
})], VStack.prototype, "noClickAnimation", void 0);

__decorate([Prop({
  type: [Boolean, Function]
})], VStack.prototype, "navigationGuard", void 0);

__decorate([Prop([String, Number])], VStack.prototype, "zIndex", void 0);

__decorate([Prop()], VStack.prototype, "contentClass", void 0);

__decorate([Prop()], VStack.prototype, "contentStyle", void 0);

__decorate([Prop()], VStack.prototype, "value", void 0);

__decorate([Prop({
  type: Boolean
})], VStack.prototype, "focusTrap", void 0);

__decorate([Watch('hasContent')], VStack.prototype, "onChangeHasContentHandler", null);

__decorate([Watch('innerActive', {
  immediate: true
})], VStack.prototype, "onChangeInnerActive", null);

__decorate([Watch('active', {
  immediate: true
})], VStack.prototype, "onChangeActiveHandler", null);

__decorate([Watch('value')], VStack.prototype, "onChangeValueHandler", null);

__decorate([Watch('$route')], VStack.prototype, "onRouteChangeHandler", null);

__decorate([Watch('alwaysRender', {
  immediate: true
})], VStack.prototype, "onChangeAlwaysRenderHandler", null);

__decorate([Watch('navigationGuard', {
  immediate: true
})], VStack.prototype, "onChangeNavigationGuardHandler", null);

VStack = __decorate([Component({
  name: 'v-stack',
  inheritAttrs: false,
  directives: {
    clickOutside: clickOutside
  }
})], VStack);
var VStack$1 = VStack;

var VStackDynamicContainer =
/*#__PURE__*/
function (_Vue) {
  _inherits(VStackDynamicContainer, _Vue);

  function VStackDynamicContainer() {
    var _this;

    _classCallCheck(this, VStackDynamicContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VStackDynamicContainer).apply(this, arguments));
    _this.settings = [];
    return _this;
  }

  _createClass(VStackDynamicContainer, [{
    key: "push",
    value: function push(setting) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var id = _this2.context.createId();

        _this2.settings.push({
          id: id,
          setting: setting,
          resolve: resolve,
          reject: reject
        });
      });
    }
  }, {
    key: "render",
    value: function render(h) {
      var _this3 = this;

      var children = this.settings.map(function (_s) {
        var id = _s.id,
            setting = _s.setting,
            resolve = _s.resolve;

        var Ctor = setting.Ctor,
            _setting$data = setting.data,
            _data = _setting$data === void 0 ? {} : _setting$data;

        var children = setting.children;
        _this3.$scopedSlots;

        var data = _objectSpread({}, _data);

        data.props = _objectSpread({
          closeOnEsc: true
        }, data.props, {
          active: true,
          alwaysRender: true
        });
        data.on = data.on || {};
        data.on.close = data.on.close || [];
        if (!Array.isArray(data.on.close)) data.on.close = [data.on.close];
        data.on.close.push(function (stack) {
          resolve(stack.payload);
        });
        data.on.afterLeave = data.on.afterLeave || [];
        if (!Array.isArray(data.on.afterLeave)) data.on.afterLeave = [data.on.afterLeave];
        data.on.afterLeave.push(function (stack) {
          var index = _this3.settings.indexOf(_s);

          if (index !== -1) {
            _this3.settings.splice(index, 1);
          }
        });
        var defaultSlot;

        if (typeof children === 'function') {
          defaultSlot = children;
        } else {
          if (typeof children === 'string' && children.indexOf('\n') !== -1) {
            var tmp = [];
            var lines = children.trim().split('\n');
            lines.forEach(function (line, index) {
              if (index !== 0) tmp.push(h('br'));
              tmp.push(line);
            });
            children = tmp;
          }
        } // if (typeof children === 'string' && children.indexOf('\n') !== -1) {
        //   const tmp: VNodeChildren = [];
        //   const lines = children.trim().split('\n');
        //   lines.forEach((line, index) => {
        //     if (index !== 0) tmp.push(h('br'));
        //     tmp.push(line);
        //   });
        //   children = tmp;
        // } else if (typeof children === 'function') {
        //   children = children();
        // }


        return h(Ctor, _objectSpread({}, data, {
          ref: 'stacks',
          refInFor: true,
          key: id,
          scopedSlots: defaultSlot ? {
            default: defaultSlot
          } : undefined
        }), defaultSlot ? undefined : children);
      });
      return h('div', {
        staticClass: 'v-stack-dynamic-container'
      }, children);
    }
  }]);

  return VStackDynamicContainer;
}(Vue);

VStackDynamicContainer = __decorate([Component({
  name: 'v-stack-dynamic-container',
  inject: {
    context: {
      from: 'stackContext'
    }
  }
})], VStackDynamicContainer);
var VStackDynamicContainer$1 = VStackDynamicContainer;

var VStackTheme =
/*#__PURE__*/
function (_Vue) {
  _inherits(VStackTheme, _Vue);

  function VStackTheme() {
    _classCallCheck(this, VStackTheme);

    return _possibleConstructorReturn(this, _getPrototypeOf(VStackTheme).apply(this, arguments));
  }

  _createClass(VStackTheme, [{
    key: "getThemeContextColor",
    value: function getThemeContextColor(key) {
      return this.$vstack.getThemeContextColor(key, this.computedTheme);
    }
  }, {
    key: "themeContext",
    get: function get() {
      return this.parentTheme || this.$vstack;
    }
  }, {
    key: "computedTheme",
    get: function get() {
      return this.theme || this.themeContext.computedTheme;
    }
  }, {
    key: "themeSettings",
    get: function get() {
      return this.$vstackSettings.themes[this.computedTheme];
    }
  }, {
    key: "themeBackgroundColor",
    get: function get() {
      return this.themeSettings.background;
    }
  }, {
    key: "themeTextColor",
    get: function get() {
      return this.themeSettings.text;
    }
  }, {
    key: "themeStyles",
    get: function get() {
      return {
        backgroundColor: this.themeBackgroundColor,
        color: this.themeTextColor
      };
    }
  }, {
    key: "themeCaptionColor",
    get: function get() {
      return this.themeSettings.text;
    }
  }]);

  return VStackTheme;
}(Vue);

__decorate([Prop({
  type: String
})], VStackTheme.prototype, "theme", void 0);

VStackTheme = __decorate([Component({
  name: 'v-stack-theme',
  provide: function provide() {
    return {
      parentTheme: this
    };
  },
  inject: {
    parentTheme: {
      default: null
    }
  }
})], VStackTheme);
var VStackTheme$1 = VStackTheme;

var isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && /iP(ad|hone|od)/.test(window.navigator.platform);
var locks = [];
var documentListenerAdded = false;
var initialClientY = -1;
var previousBodyOverflowSetting;
var previousBodyPaddingRight; // returns true if `el` should be allowed to receive touchmove events.

var allowTouchMove = function allowTouchMove(el) {
  return locks.some(function (lock) {
    if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) {
      return true;
    }

    return false;
  });
};

var preventDefault = function preventDefault(rawEvent) {
  var e = rawEvent || window.event; // For the case whereby consumers adds a touchmove event listener to document.
  // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
  // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
  // the touchmove event on document will break.

  if (allowTouchMove(e.target)) {
    return true;
  } // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).


  if (e.touches.length > 1) return true;
  if (e.preventDefault) e.preventDefault();
  return false;
};

var setOverflowHidden = function setOverflowHidden(options) {
  // Setting overflow on body/documentElement synchronously in Desktop Safari slows down
  // the responsiveness for some reason. Setting within a setTimeout fixes this.
  setTimeout(function () {
    // If previousBodyPaddingRight is already set, don't set it again.
    if (previousBodyPaddingRight === undefined) {
      var reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
      var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;

      if (reserveScrollBarGap && scrollBarGap > 0) {
        previousBodyPaddingRight = document.body.style.paddingRight;
        document.body.style.paddingRight = "".concat(scrollBarGap, "px");
      }
    } // If previousBodyOverflowSetting is already set, don't set it again.


    if (previousBodyOverflowSetting === undefined) {
      previousBodyOverflowSetting = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
  });
};

var restoreOverflowSetting = function restoreOverflowSetting() {
  // Setting overflow on body/documentElement synchronously in Desktop Safari slows down
  // the responsiveness for some reason. Setting within a setTimeout fixes this.
  setTimeout(function () {
    if (previousBodyPaddingRight !== undefined) {
      document.body.style.paddingRight = previousBodyPaddingRight; // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
      // can be set again.

      previousBodyPaddingRight = undefined;
    }

    if (previousBodyOverflowSetting !== undefined) {
      document.body.style.overflow = previousBodyOverflowSetting; // Restore previousBodyOverflowSetting to undefined
      // so setOverflowHidden knows it can be set again.

      previousBodyOverflowSetting = undefined;
    }
  });
}; // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions


var isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
  return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};

var handleScroll = function handleScroll(event, targetElement) {
  var clientY = event.targetTouches[0].clientY - initialClientY;

  if (allowTouchMove(event.target)) {
    return false;
  }

  if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
    // element is at the top of its scroll.
    return preventDefault(event);
  }

  if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
    // element is at the top of its scroll.
    return preventDefault(event);
  }

  event.stopPropagation();
  return true;
};

var disableBodyScroll = function disableBodyScroll(targetElement, options) {
  if (isIosDevice) {
    // targetElement must be provided, and disableBodyScroll must not have been
    // called on this targetElement before.
    if (!targetElement) {
      // eslint-disable-next-line no-console
      console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
      return;
    }

    if (targetElement && !locks.some(function (lock) {
      return lock.targetElement === targetElement;
    })) {
      var lock = {
        targetElement: targetElement,
        options: options || {}
      };
      locks = [].concat(_toConsumableArray(locks), [lock]);

      targetElement.ontouchstart = function (event) {
        if (event.targetTouches.length === 1) {
          // detect single touch.
          initialClientY = event.targetTouches[0].clientY;
        }
      };

      targetElement.ontouchmove = function (event) {
        if (event.targetTouches.length === 1) {
          // detect single touch.
          handleScroll(event, targetElement);
        }
      };

      if (!documentListenerAdded) {
        document.addEventListener('touchmove', preventDefault, SUPPORTS_PASSIVE ? {
          passive: false
        } : undefined);
        documentListenerAdded = true;
      }
    }
  } else {
    setOverflowHidden(options);
    var _lock = {
      targetElement: targetElement,
      options: options || {}
    };
    locks = [].concat(_toConsumableArray(locks), [_lock]);
  }
};
var enableBodyScroll = function enableBodyScroll(targetElement) {
  if (isIosDevice) {
    if (!targetElement) {
      // eslint-disable-next-line no-console
      console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
      return;
    }

    targetElement.ontouchstart = null;
    targetElement.ontouchmove = null;
    locks = locks.filter(function (lock) {
      return lock.targetElement !== targetElement;
    });

    if (documentListenerAdded && locks.length === 0) {
      document.removeEventListener('touchmove', preventDefault, SUPPORTS_PASSIVE ? {
        passive: false
      } : undefined);
      documentListenerAdded = false;
    }
  } else {
    locks = locks.filter(function (lock) {
      return lock.targetElement !== targetElement;
    });

    if (!locks.length) {
      restoreOverflowSetting();
    }
  }
};

var BODY_SCROLL_LOCK_SCROLL_ATTRIBUTE = 'data-vstack-scroll-lock-scroller';

var Stacks =
/*#__PURE__*/
function () {
  function Stacks() {
    _classCallCheck(this, Stacks);

    this.els = [];
    this.active = false;
  }

  _createClass(Stacks, [{
    key: "check",
    value: function check() {
      var active = this.els.length > 0;

      if (active && !this.active) {
        this.activate();
      } else if (!active && this.active) {
        this.deactivate();
      }
    }
  }, {
    key: "activate",
    value: function activate() {
      document.documentElement.setAttribute('data-vstack-body-scroll-lock', '');
      this.active = true;
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      document.documentElement.removeAttribute('data-vstack-body-scroll-lock');
      this.active = false;
    }
  }, {
    key: "push",
    value: function push(el) {
      if (!this.els.includes(el)) {
        var lockElement = el.querySelector("[".concat(BODY_SCROLL_LOCK_SCROLL_ATTRIBUTE, "]")) || el;
        disableBodyScroll(lockElement);
        this.els.push(el);
        this.check();
      }
    }
  }, {
    key: "remove",
    value: function remove(el) {
      var index = this.els.indexOf(el);

      if (index !== -1) {
        var lockElement = el.querySelector("[".concat(BODY_SCROLL_LOCK_SCROLL_ATTRIBUTE, "]")) || el;
        enableBodyScroll(lockElement);
        this.els.splice(index, 1);
        this.check();
      }
    }
  }]);

  return Stacks;
}();

var stacks = new Stacks();
var bodyScrollLock = {
  name: 'body-scroll-lock',
  inserted: function inserted(el, binding, vnode) {
    if (vnode.context && !vnode.context.$vstackSettings.useScrollStop) {
      return;
    }

    binding.value && stacks.push(el);
  },
  componentUpdated: function componentUpdated(el, binding, vnode) {
    if (vnode.context && !vnode.context.$vstackSettings.useScrollStop) {
      return;
    }

    if (binding.value) {
      stacks.push(el);
    } else {
      stacks.remove(el);
    }
  },
  unbind: function unbind(el) {
    stacks.remove(el);
  }
};

var DEFAULT_CONTAINER_MARGIN = 20;
var DEFAULT_DISTANCE = 10;
var DEFAULT_RESIZE_WATCH_DEBOUNCE = 250;

var VStackMenu =
/*#__PURE__*/
function (_Mixins) {
  _inherits(VStackMenu, _Mixins);

  function VStackMenu() {
    var _this;

    _classCallCheck(this, VStackMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VStackMenu).apply(this, arguments));
    _this.pageXOffset = 0;
    _this.pageYOffset = 0;
    _this.rect = null;
    _this.activatorRect = null;
    _this.resizeWatchTimerId = null;
    return _this;
  }

  _createClass(VStackMenu, [{
    key: "updatePageOffset",
    value: function updatePageOffset() {
      var _document = document,
          scrollingElement = _document.scrollingElement;

      if (!scrollingElement) {
        warn$1('missing document.scrollingElement try use polyfill');
        return;
      }

      this.pageXOffset = scrollingElement.scrollLeft;
      this.pageYOffset = scrollingElement.scrollTop;
    }
  }, {
    key: "onContentReady",
    value: function onContentReady() {
      this.updateRects();
      this.startResizeWatch();
    }
  }, {
    key: "startResizeWatch",
    value: function startResizeWatch() {
      var _this2 = this;

      if (typeof window === 'undefined') return;
      this.clearResizeWatch();

      this._resizeWatchHandler = function () {
        _this2.resizeWatchTimerId = window.setTimeout(function () {
          _this2.clearResizeWatch();

          _this2.updateRects();
        }, _this2.computedResizeWatchDebounce);
      };

      window.addEventListener('resize', this._resizeWatchHandler, false);
    }
  }, {
    key: "clearResizeWatch",
    value: function clearResizeWatch() {
      if (this.resizeWatchTimerId !== null) {
        clearTimeout(this.resizeWatchTimerId);
        this.resizeWatchTimerId = null;
      }
    }
  }, {
    key: "updateRects",
    value: function updateRects() {
      this.updatePageOffset();
      this.updateMyRect();
      this.updateActivatorRect();
    }
  }, {
    key: "updateMyRect",
    value: function updateMyRect() {
      var content = this.$refs.content;

      if (!content) {
        this.rect = null;
        return;
      }

      var originalDisplay = content.style.display;
      var originalWidth = content.style.width;
      var originalHeight = content.style.height;
      var originalMaxWidth = content.style.maxWidth;
      var originalMaxHeight = content.style.maxHeight;
      content.style.display = '';
      content.style.width = '';
      content.style.height = '';
      content.style.maxWidth = '';
      content.style.maxHeight = '';
      var rect = content.getBoundingClientRect();
      content.style.display = originalDisplay;
      content.style.width = originalWidth;
      content.style.height = originalHeight;
      content.style.maxWidth = originalMaxWidth;
      content.style.maxHeight = originalMaxHeight;
      this.rect = {
        left: rect.left,
        right: rect.right,
        top: rect.top,
        bottom: rect.bottom,
        width: rect.width,
        height: rect.height
      };
    }
  }, {
    key: "updateActivatorRect",
    value: function updateActivatorRect() {
      var $activator = this.$activator;

      if (!$activator) {
        this.activatorRect = null;
        return;
      }

      var rect = $activator.getBoundingClientRect();
      this.activatorRect = {
        left: rect.left,
        right: rect.right,
        top: rect.top,
        bottom: rect.bottom,
        width: rect.width,
        height: rect.height
      };
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      this.clearResizeWatch();
    }
  }, {
    key: "renderContent",
    value: function renderContent(h) {
      var defaultSlot = this.$scopedSlots.default;
      return {
        tag: 'div',
        data: {
          staticClass: 'v-stack-menu',
          directives: [{
            name: 'body-scroll-lock',
            value: this.isActive
          }],
          style: _objectSpread({}, this.menuStyles, this.themeStyles)
        },
        children: defaultSlot && defaultSlot(this)
      };
    }
  }, {
    key: "computedDistance",
    get: function get() {
      return toNumber(this.distance);
    }
  }, {
    key: "computedResizeWatchDebounce",
    get: function get() {
      return toNumber(this.resizeWatchDebounce);
    }
  }, {
    key: "computedEdgeMargin",
    get: function get() {
      return toNumber(this.edgeMargin);
    }
  }, {
    key: "minLeft",
    get: function get() {
      return this.computedEdgeMargin + this.pageXOffset;
    }
  }, {
    key: "minTop",
    get: function get() {
      return this.computedEdgeMargin + this.pageYOffset;
    }
  }, {
    key: "maxRight",
    get: function get() {
      return this.$vstack.width - this.computedEdgeMargin + this.pageXOffset;
    }
  }, {
    key: "maxBottom",
    get: function get() {
      return this.$vstack.height - this.computedEdgeMargin + this.pageYOffset;
    }
  }, {
    key: "computedWidth",
    get: function get() {
      var width = this.width;
      if (width === 'fit') return width;
      if (width !== undefined) return toNumber(width);
    }
  }, {
    key: "computedHeight",
    get: function get() {
      var height = this.height;
      if (height === 'fit') return height;
      if (height !== undefined) return toNumber(height);
    }
  }, {
    key: "computedMaxWidth",
    get: function get() {
      var maxWidth = this.maxWidth;
      if (maxWidth !== undefined) return toNumber(maxWidth);
    }
  }, {
    key: "computedMaxHeight",
    get: function get() {
      var maxHeight = this.maxHeight;
      if (maxHeight !== undefined) return toNumber(maxHeight);
    }
  }, {
    key: "positionFlags",
    get: function get() {
      var left = this.left,
          right = this.right,
          top = this.top,
          bottom = this.bottom;
      if (!top && !bottom && !left && !right) bottom = true;
      if (top && bottom) warn$1('top and bottom can not be specified at the same time.');
      if (left && right) warn$1('left and right can not be specified at the same time.');
      return {
        left: left,
        right: right,
        top: top,
        bottom: bottom
      };
    }
  }, {
    key: "computedTransition",
    get: function get() {
      var transition = this.transition;
      if (transition !== 'auto') return transition;
      var _this$positionFlags = this.positionFlags,
          right = _this$positionFlags.right,
          top = _this$positionFlags.top,
          bottom = _this$positionFlags.bottom;
      if (bottom) return 'v-stack-slide-y';
      if (top) return 'v-stack-slide-y-reverse';
      if (right) return 'v-stack-slide-x';
      return 'v-stack-slide-x-reverse';
    }
  }, {
    key: "computedRect",
    get: function get() {
      var rect = this.rect,
          activatorRect = this.activatorRect;
      if (!rect) return null;
      if (!activatorRect) return null;
      var allowOverflow = this.allowOverflow,
          pageXOffset = this.pageXOffset,
          pageYOffset = this.pageYOffset,
          minLeft = this.minLeft,
          minTop = this.minTop,
          maxRight = this.maxRight,
          maxBottom = this.maxBottom,
          computedDistance = this.computedDistance,
          overlap = this.overlap;
      var computedWidth = this.computedWidth,
          computedHeight = this.computedHeight,
          computedMaxWidth = this.computedMaxWidth,
          computedMaxHeight = this.computedMaxHeight;
      var left, top, width, height;
      var myWidth = rect.width,
          myHeight = rect.height;
      var activatorTop = activatorRect.top,
          activatorLeft = activatorRect.left,
          activatorRight = activatorRect.right,
          activatorBottom = activatorRect.bottom,
          activatorWidth = activatorRect.width,
          activatorHeight = activatorRect.height;
      if (computedWidth === 'fit') computedWidth = Math.max(activatorWidth, myWidth);
      if (computedHeight === 'fit') computedHeight = Math.max(activatorHeight, myHeight);
      if (computedMaxWidth === 'fit') computedMaxWidth = activatorWidth;
      if (computedMaxHeight === 'fit') computedMaxHeight = activatorHeight;
      var _this$positionFlags2 = this.positionFlags,
          isTop = _this$positionFlags2.top,
          isBottom = _this$positionFlags2.bottom,
          isLeft = _this$positionFlags2.left,
          isRight = _this$positionFlags2.right;
      width = typeof computedWidth === 'number' ? computedWidth : myWidth;
      height = typeof computedHeight === 'number' ? computedHeight : myHeight;

      if (typeof computedMaxWidth === 'number' && width > computedMaxWidth) {
        width = computedMaxWidth;
      }

      if (typeof computedMaxHeight === 'number' && height > computedMaxHeight) {
        height = computedMaxHeight;
      }

      if (isTop) {
        top = activatorTop - height;
        if (overlap) top += activatorHeight;
      } else if (isBottom) {
        top = activatorBottom;
        if (overlap) top -= activatorHeight;
      } else {
        top = activatorTop - (height - activatorHeight) / 2;
      }

      top += pageYOffset;

      if (isLeft) {
        left = activatorLeft - width;
        if (overlap) left += activatorWidth;
      } else if (isRight) {
        left = activatorRight;
        if (overlap) left -= activatorWidth;
      } else {
        left = activatorLeft - (width - activatorWidth) / 2;
      }

      left += pageXOffset;

      if (!overlap) {
        if (isBottom) {
          top += computedDistance;
        } else if (isTop) {
          top -= computedDistance;
        }

        if (isRight) {
          left += computedDistance;
        } else if (isLeft) {
          left -= computedDistance;
        }
      }

      var right = left + width;
      var bottom = top + height;
      var rightDiff = right - maxRight;

      if (rightDiff > 0) {
        left -= rightDiff;
        right -= rightDiff;
      }

      var bottomDiff = bottom - maxBottom;

      if (bottomDiff > 0) {
        top -= bottomDiff;
        bottom -= bottomDiff;
      }

      var leftDiff = minLeft - left;

      if (leftDiff > 0) {
        left += leftDiff;
        right += leftDiff;
      }

      var topDiff = minTop - top;

      if (topDiff > 0) {
        top += topDiff;
        bottom += topDiff;
      }

      if (!allowOverflow) {
        var overflowX = right - maxRight;

        if (overflowX > 0) {
          width -= overflowX;
          right -= overflowX;
        }

        var overflowY = bottom - maxBottom;

        if (overflowY > 0) {
          height -= overflowY;
          bottom -= overflowY;
        }
      }

      return {
        left: left,
        right: right,
        top: top,
        bottom: bottom,
        width: width,
        height: height
      };
    }
  }, {
    key: "menuStyles",
    get: function get() {
      var styles = {
        position: 'absolute'
      };
      var computedRect = this.computedRect;

      if (computedRect) {
        styles.left = computedRect.left + 'px';
        styles.top = computedRect.top + 'px';
        styles.width = computedRect.width + 'px';
        styles.height = computedRect.height + 'px';
      } else {
        styles.visibility = 'hidden';
      }

      return styles;
    }
  }]);

  return VStackMenu;
}(mixins(VStack$1, VStackTheme$1));

__decorate([Prop({
  type: String,
  default: 'auto'
})], VStackMenu.prototype, "transition", void 0);

__decorate([Prop({
  type: Boolean
})], VStackMenu.prototype, "top", void 0);

__decorate([Prop({
  type: Boolean
})], VStackMenu.prototype, "bottom", void 0);

__decorate([Prop({
  type: Boolean
})], VStackMenu.prototype, "left", void 0);

__decorate([Prop({
  type: Boolean
})], VStackMenu.prototype, "right", void 0);

__decorate([Prop({
  type: Boolean
})], VStackMenu.prototype, "allowOverflow", void 0);

__decorate([Prop({
  type: [Number, String]
})], VStackMenu.prototype, "width", void 0);

__decorate([Prop({
  type: [Number, String]
})], VStackMenu.prototype, "height", void 0);

__decorate([Prop({
  type: [Number, String]
})], VStackMenu.prototype, "maxWidth", void 0);

__decorate([Prop({
  type: [Number, String]
})], VStackMenu.prototype, "maxHeight", void 0);

__decorate([Prop({
  type: [Number, String],
  default: DEFAULT_DISTANCE
})], VStackMenu.prototype, "distance", void 0);

__decorate([Prop({
  type: [Number, String],
  default: DEFAULT_CONTAINER_MARGIN
})], VStackMenu.prototype, "edgeMargin", void 0);

__decorate([Prop({
  type: [Number, String],
  default: DEFAULT_RESIZE_WATCH_DEBOUNCE
})], VStackMenu.prototype, "resizeWatchDebounce", void 0);

__decorate([Prop({
  type: Boolean
})], VStackMenu.prototype, "overlap", void 0);

VStackMenu = __decorate([Component({
  name: 'v-stack-menu',
  directives: {
    bodyScrollLock: bodyScrollLock
  }
})], VStackMenu);
var VStackMenu$1 = VStackMenu;

function transform(el, value) {
  el.style['transform'] = value;
  el.style['webkitTransform'] = value;
}

function opacity(el, value) {
  el.style['opacity'] = value.toString();
}

function isTouchEvent(e) {
  return e.constructor.name === 'TouchEvent';
}

var calculate = function calculate(e, el) {
  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var offset = el.getBoundingClientRect();
  var target = isTouchEvent(e) ? e.touches[e.touches.length - 1] : e;
  var localX = target.clientX - offset.left;
  var localY = target.clientY - offset.top;
  var radius = 0;
  var scale = 0.3;

  if (el._ripple && el._ripple.circle) {
    scale = 0.15;
    radius = el.clientWidth / 2;
    radius = value.center ? radius : radius + Math.sqrt(Math.pow(localX - radius, 2) + Math.pow(localY - radius, 2)) / 4;
  } else {
    radius = Math.sqrt(Math.pow(el.clientWidth, 2) + Math.pow(el.clientHeight, 2)) / 2;
  }

  var centerX = "".concat((el.clientWidth - radius * 2) / 2, "px");
  var centerY = "".concat((el.clientHeight - radius * 2) / 2, "px");
  var x = value.center ? centerX : "".concat(localX - radius, "px");
  var y = value.center ? centerY : "".concat(localY - radius, "px");
  return {
    radius: radius,
    scale: scale,
    x: x,
    y: y,
    centerX: centerX,
    centerY: centerY
  };
};

var ripple = {
  /* eslint-disable max-statements */
  show: function show(e, el) {
    var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!el._ripple || !el._ripple.enabled) {
      return;
    }

    var container = document.createElement('span');
    var animation = document.createElement('span');
    container.appendChild(animation);
    container.className = 'v-stack-ripple__container';

    if (value.class) {
      container.className += " ".concat(value.class);
    }

    var _calculate = calculate(e, el, value),
        radius = _calculate.radius,
        scale = _calculate.scale,
        x = _calculate.x,
        y = _calculate.y,
        centerX = _calculate.centerX,
        centerY = _calculate.centerY;

    var size = "".concat(radius * 2, "px");
    animation.className = 'v-stack-ripple__animation';
    animation.style.width = size;
    animation.style.height = size;
    el.appendChild(container);
    var computed = window.getComputedStyle(el);

    if (computed && computed.position === 'static') {
      el.style.position = 'relative';
      el.dataset.previousPosition = 'static';
    }

    animation.classList.add('v-stack-ripple__animation--enter');
    animation.classList.add('v-stack-ripple__animation--visible');
    transform(animation, "translate(".concat(x, ", ").concat(y, ") scale3d(").concat(scale, ",").concat(scale, ",").concat(scale, ")"));
    opacity(animation, 0);
    animation.dataset.activated = String(performance.now());
    setTimeout(function () {
      animation.classList.remove('v-stack-ripple__animation--enter');
      animation.classList.add('v-stack-ripple__animation--in');
      transform(animation, "translate(".concat(centerX, ", ").concat(centerY, ") scale3d(1,1,1)"));
      opacity(animation, 0.25);
    }, 0);
  },
  hide: function hide(el) {
    if (!el || !el._ripple || !el._ripple.enabled) return;
    var ripples = el.getElementsByClassName('v-stack-ripple__animation');
    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    if (animation.dataset.isHiding) return;else animation.dataset.isHiding = 'true';
    var diff = performance.now() - Number(animation.dataset.activated);
    var delay = Math.max(250 - diff, 0);
    setTimeout(function () {
      animation.classList.remove('v-stack-ripple__animation--in');
      animation.classList.add('v-stack-ripple__animation--out');
      opacity(animation, 0);
      setTimeout(function () {
        var ripples = el.getElementsByClassName('v-stack-ripple__animation');

        if (ripples.length === 1 && el.dataset.previousPosition) {
          el.style.position = el.dataset.previousPosition;
          delete el.dataset.previousPosition;
        }

        animation.parentNode && el.removeChild(animation.parentNode);
      }, 300);
    }, delay);
  }
};

function isRippleEnabled(value) {
  return typeof value === 'undefined' || !!value;
}

function rippleShow(e) {
  var value = {};
  var element = e.currentTarget;
  if (!element || !element._ripple || element._ripple.touched) return;

  if (isTouchEvent(e)) {
    element._ripple.touched = true;
  }

  value.center = element._ripple.centered;

  if (element._ripple.class) {
    value.class = element._ripple.class;
  }

  ripple.show(e, element, value);
}

function rippleHide(e) {
  var element = e.currentTarget;
  if (!element) return;
  window.setTimeout(function () {
    if (element._ripple) {
      element._ripple.touched = false;
    }
  });
  ripple.hide(element);
}

function updateRipple(el, binding, wasEnabled) {
  var enabled = isRippleEnabled(binding.value);

  if (!enabled) {
    ripple.hide(el);
  }

  el._ripple = el._ripple || {};
  el._ripple.enabled = enabled;
  var value = binding.value || {};

  if (value.center) {
    el._ripple.centered = true;
  }

  if (value.class) {
    el._ripple.class = binding.value.class;
  }

  if (value.circle) {
    el._ripple.circle = value.circle;
  }

  if (enabled && !wasEnabled) {
    el.addEventListener('touchstart', rippleShow, {
      passive: true
    });
    el.addEventListener('touchend', rippleHide, {
      passive: true
    });
    el.addEventListener('touchcancel', rippleHide);
    el.addEventListener('mousedown', rippleShow);
    el.addEventListener('mouseup', rippleHide);
    el.addEventListener('mouseleave', rippleHide); // Anchor tags can be dragged, causes other hides to fail - #1537

    el.addEventListener('dragstart', rippleHide, {
      passive: true
    });
  } else if (!enabled && wasEnabled) {
    removeListeners(el);
  }
}

function removeListeners(el) {
  el.removeEventListener('mousedown', rippleShow);
  el.removeEventListener('touchstart', rippleHide);
  el.removeEventListener('touchend', rippleHide);
  el.removeEventListener('touchcancel', rippleHide);
  el.removeEventListener('mouseup', rippleHide);
  el.removeEventListener('mouseleave', rippleHide);
  el.removeEventListener('dragstart', rippleHide);
}

function directive$1(el, binding, node) {
  updateRipple(el, binding, false); // warn if an inline element is used, waiting for el to be in the DOM first

  node.context && node.context.$nextTick(function () {
    var computed = window.getComputedStyle(el);

    if (computed && computed.display === 'inline') {
      var _console;

      var context = node.fnOptions ? [node.fnOptions, node.context] : [node.componentInstance];

      (_console = console).warn.apply(_console, ['v-ripple can only be used on block-level elements'].concat(context));
    }
  });
}

function unbind(el) {
  delete el._ripple;
  removeListeners(el);
}

function update(el, binding) {
  if (binding.value === binding.oldValue) {
    return;
  }

  var wasEnabled = isRippleEnabled(binding.oldValue);
  updateRipple(el, binding, wasEnabled);
}

var ripple$1 = {
  bind: directive$1,
  unbind: unbind,
  update: update
};

var VStackThemeItem =
/*#__PURE__*/
function (_Vue) {
  _inherits(VStackThemeItem, _Vue);

  function VStackThemeItem() {
    _classCallCheck(this, VStackThemeItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(VStackThemeItem).apply(this, arguments));
  }

  _createClass(VStackThemeItem, [{
    key: "fill",
    get: function get() {
      return !this.outline && !this.flat;
    }
  }, {
    key: "computedColor",
    get: function get() {
      return this.color || 'primary';
    }
  }, {
    key: "themeContext",
    get: function get() {
      return this.parentTheme || this.$vstack;
    }
  }, {
    key: "computedTheme",
    get: function get() {
      return this.themeContext.computedTheme;
    }
  }, {
    key: "themeSettings",
    get: function get() {
      return this.$vstackSettings.themes[this.computedTheme];
    }
  }, {
    key: "contextColor",
    get: function get() {
      return this.themeContext.getThemeContextColor(this.computedColor);
    }
  }, {
    key: "contextColorStyles",
    get: function get() {
      var contextColor = this.contextColor;

      if (this.flat) {
        return {
          color: contextColor.base
        };
      } else if (this.outline) {
        return {
          color: contextColor.base,
          borderColor: contextColor.base
        };
      } else if (this.fill) {
        return {
          backgroundColor: contextColor.base,
          color: contextColor.text
        };
      }
    }
  }]);

  return VStackThemeItem;
}(Vue);

__decorate([Prop({
  type: String
})], VStackThemeItem.prototype, "color", void 0);

__decorate([Prop({
  type: Boolean
})], VStackThemeItem.prototype, "flat", void 0);

__decorate([Prop({
  type: Boolean
})], VStackThemeItem.prototype, "outline", void 0);

VStackThemeItem = __decorate([Component({
  name: 'v-stack-theme-item',
  inject: {
    parentTheme: {
      default: null
    }
  }
})], VStackThemeItem);
var VStackThemeItem$1 = VStackThemeItem;

var CLICKABLE_TAGS = ['a', 'button', 'router-link', 'nuxt-link'];

var VStackBtn =
/*#__PURE__*/
function (_Mixins) {
  _inherits(VStackBtn, _Mixins);

  function VStackBtn() {
    _classCallCheck(this, VStackBtn);

    return _possibleConstructorReturn(this, _getPrototypeOf(VStackBtn).apply(this, arguments));
  }

  _createClass(VStackBtn, [{
    key: "focus",
    value: function focus() {
      return this.$el.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      return this.$el.blur();
    }
  }, {
    key: "clickHandler",
    value: function clickHandler(e) {
      if (!this.arrowAction) {
        e.preventDefault();
        return;
      }

      this.$emit('click', e);
    }
  }, {
    key: "render",
    value: function render(h) {
      var _this = this;

      var tag = this.computedTag,
          $listeners = this.$listeners,
          disabled = this.disabled,
          to = this.to,
          exact = this.exact,
          append = this.append,
          replace = this.replace,
          href = this.href,
          target = this.target,
          type = this.type,
          tabindex = this.tabindex,
          arrowAction = this.arrowAction;
      var data = {
        staticClass: 'v-stack-btn',
        class: this.classes,
        style: this.styles,
        attrs: {
          disabled: disabled,
          tabindex: arrowAction ? tabindex : '-1'
        },
        nativeOn: to ? {
          click: this.clickHandler
        } : undefined,
        on: _objectSpread({}, $listeners, {
          focus: function focus(e) {
            _this.$emit('focus', e);
          },
          blur: function blur(e) {
            _this.$emit('blur', e);
          }
        }, !to ? {
          click: this.clickHandler
        } : undefined),
        directives: [{
          name: 'ripple',
          value: this.computedRipple
        }]
      };

      if (to) {
        data.props = _objectSpread({}, data.props, {
          to: to,
          exact: exact,
          append: append,
          replace: replace
        });
      } else {
        if (tag === 'a' && href) {
          data.attrs.href = href;
        }

        if (tag === 'button') {
          data.attrs.type = type;
        }
      }

      if (target) data.attrs.target = target;
      return h(tag, data, [h('span', {
        staticClass: 'v-stack-btn__content'
      }, this.$slots.default)]);
    }
  }, {
    key: "arrowAction",
    get: function get() {
      return this.isClickableTag && !this.disabled;
    }
  }, {
    key: "computedRipple",
    get: function get() {
      var defaultRipple = true;
      if (this.disabled) return false;else return this.ripple !== null ? this.ripple : defaultRipple;
    }
  }, {
    key: "classes",
    get: function get() {
      var classes = {
        'v-stack-btn--fill': this.fill,
        'v-stack-btn--flat': this.flat,
        'v-stack-btn--outline': this.outline,
        'v-stack-btn--noaction': !this.arrowAction,
        'v-stack-btn--disabled': this.disabled,
        'v-stack-btn--depressed': this.depressed
      };
      return classes;
    }
  }, {
    key: "computedColor",
    get: function get() {
      if (this.disabled) return 'muted';
      return this.color || 'primary';
    }
  }, {
    key: "styles",
    get: function get() {
      return _objectSpread({}, this.contextColorStyles);
    }
  }, {
    key: "computedTag",
    get: function get() {
      var tag = this.tag,
          to = this.to;

      if (to) {
        tag = this.$nuxt ? 'nuxt-link' : 'router-link';
      } else if (this.href || !tag) {
        tag = 'a';
      }

      return tag;
    }
  }, {
    key: "isClickableTag",
    get: function get() {
      return CLICKABLE_TAGS.includes(this.computedTag);
    }
  }]);

  return VStackBtn;
}(mixins(VStackThemeItem$1));

__decorate([Prop({
  type: String,
  default: 'button'
})], VStackBtn.prototype, "tag", void 0);

__decorate([Prop({
  type: Boolean
})], VStackBtn.prototype, "disabled", void 0);

__decorate([Prop({
  type: Boolean
})], VStackBtn.prototype, "append", void 0);

__decorate([Prop({
  type: Boolean
})], VStackBtn.prototype, "exact", void 0);

__decorate([Prop({
  type: Boolean
})], VStackBtn.prototype, "replace", void 0);

__decorate([Prop({
  type: [String, Object]
})], VStackBtn.prototype, "to", void 0);

__decorate([Prop({
  type: String
})], VStackBtn.prototype, "href", void 0);

__decorate([Prop({
  type: String
})], VStackBtn.prototype, "target", void 0);

__decorate([Prop({
  type: String
})], VStackBtn.prototype, "type", void 0);

__decorate([Prop({
  type: [String, Number]
})], VStackBtn.prototype, "tabindex", void 0);

__decorate([Prop({
  type: Boolean
})], VStackBtn.prototype, "depressed", void 0);

__decorate([Prop({
  type: [Boolean, Object],
  default: null
})], VStackBtn.prototype, "ripple", void 0);

VStackBtn = __decorate([Component({
  name: 'v-stack-btn',
  directives: {
    ripple: ripple$1
  }
})], VStackBtn);
var VStackBtn$1 = VStackBtn;

var toStyleWidth = function toStyleWidth(width) {
  if (typeof width === 'number') return width + 'px';
  return isNaN(width) ? width : width + 'px';
};

function resoveRawVStackDialogPromptSettings(settings) {
  if (typeof settings === 'string') {
    settings = {
      type: settings
    };
  }

  return _objectSpread({}, settings, {
    type: settings.type || 'text'
  });
}

var VStackDialog =
/*#__PURE__*/
function (_Mixins) {
  _inherits(VStackDialog, _Mixins);

  function VStackDialog() {
    _classCallCheck(this, VStackDialog);

    return _possibleConstructorReturn(this, _getPrototypeOf(VStackDialog).apply(this, arguments));
  }

  _createClass(VStackDialog, [{
    key: "tryGetVNodeChildren",
    value: function tryGetVNodeChildren(scopedSlot, children) {
      if (typeof scopedSlot === 'function') return scopedSlot(this);
      return children;
    }
  }, {
    key: "genStackDialogHeader",
    value: function genStackDialogHeader() {
      var header = this.header;

      if (typeof header === 'function') {
        header = header(this);
      }

      var children = this.tryGetVNodeChildren(this.$scopedSlots.header, header);
      if (!children) return;
      return this.$createElement('div', {
        staticClass: "".concat(this.baseClassName, "__header")
      }, children);
    }
  }, {
    key: "createAdditionalBody",
    value: function createAdditionalBody(h) {}
  }, {
    key: "genStackDialogBody",
    value: function genStackDialogBody() {
      var _this = this;

      var defaultSlot = this.$scopedSlots.default;
      var additionalBody = this.createAdditionalBody(this.$createElement);
      var children = additionalBody || defaultSlot && defaultSlot(this);
      var h = this.$createElement;
      var prompt = this.computedPrompt;

      if (prompt) {
        // console.log(this.getThemeContextColor('field'))
        var filedColor = this.getThemeContextColor('field');
        var primaryColor = this.getThemeContextColor('primary');
        var _children = children;
        children = [h('form', {
          staticClass: 'v-stack-prompt-form',
          on: {
            submit: function submit(e) {
              e.preventDefault();
              var promptInput = _this.$refs.promptInput;
              var value = promptInput && promptInput.value;

              _this.resolve(value);
            }
          }
        }, [h('input', {
          staticClass: 'v-stack-prompt-input',
          style: {
            background: filedColor.base,
            color: filedColor.text,
            borderColor: primaryColor.base
          },
          attrs: {
            type: prompt.type,
            autofocus: true
          },
          domProps: {
            value: prompt.value == null ? '' : String(prompt.value)
          },
          ref: 'promptInput'
        })])];

        if (_children) {
          children.unshift(h('div', {
            staticClass: 'v-stack-prompt-content'
          }, _children));
        }
      }

      return this.$createElement('div', {
        staticClass: "".concat(this.baseClassName, "__body")
      }, children);
    }
  }, {
    key: "genStackDialogActions",
    value: function genStackDialogActions() {
      var _this2 = this;

      var actions = this.actions,
          h = this.$createElement,
          $scopedSlots = this.$scopedSlots,
          baseClassName = this.baseClassName;
      if (!actions || actions.length === 0) return;
      var defaultActionSlot = $scopedSlots.action;
      var children = [];
      actions.forEach(function (action) {
        var actionSlot = action.slot || defaultActionSlot;
        var on = {
          click: function click(e) {
            if (!e.defaultPrevented && action.click) action.click(_this2, action, e);
          }
        };

        if (actionSlot) {
          var vNodes = actionSlot(_objectSpread({}, action, {
            dialog: _this2,
            on: on
          }));
          if (vNodes) children.push.apply(children, _toConsumableArray(vNodes));
        } else {
          children.push(h(VStackBtn$1, {
            props: {
              type: 'button',
              color: action.color,
              outline: action.outline
            },
            staticClass: "".concat(baseClassName, "__action ").concat(baseClassName, "__action--").concat(action.type),
            class: _defineProperty({}, "".concat(baseClassName, "__action--spacer"), action.spacer),
            attrs: {
              autofocus: action.autofocus
            },
            on: on,
            key: action.type
          }, typeof action.text === 'function' ? action.text(_this2) : action.text));
        }
      });
      return this.$createElement('div', {
        staticClass: "".concat(this.baseClassName, "__actions")
      }, children);
    }
  }, {
    key: "genStackDialogContent",
    value: function genStackDialogContent() {
      var children = [];
      var $header = this.genStackDialogHeader();
      var $body = this.genStackDialogBody();
      var $actions = this.genStackDialogActions();
      if ($header) children.push($header);
      children.push($body);
      if ($actions) children.push($actions);
      return this.$createElement('div', {
        staticClass: "".concat(this.baseClassName, "__content"),
        style: this.contentStyles,
        attrs: {
          tabindex: '0'
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
          }
        }
      }, children);
    }
  }, {
    key: "renderContent",
    value: function renderContent(h) {
      var _this3 = this;

      var baseClassName = this.baseClassName,
          dialogType = this.dialogType;
      var children = [];
      var $scroller = h('div', {
        staticClass: "".concat(baseClassName, "__scroller")
      }, [h('div', {
        staticClass: "".concat(baseClassName, "__centerer")
      }, [this.genStackDialogContent()])]);
      children.push($scroller);
      var staticClass = baseClassName;

      if (dialogType) {
        staticClass = "".concat(staticClass, " ").concat(baseClassName, "--").concat(dialogType);
      }

      return {
        tag: 'div',
        data: {
          staticClass: staticClass,
          directives: [{
            name: 'body-scroll-lock',
            value: this.isActive
          }],
          on: {
            click: function click(e) {
              if (_this3.closeOnClick && _this3.closeConditional(e)) {
                _this3.close();
              }
            }
          }
        },
        children: children
      };
    }
  }, {
    key: "computedPrompt",
    get: function get() {
      var prompt = this.prompt;

      if (prompt) {
        return resoveRawVStackDialogPromptSettings(prompt);
      }
    }
  }, {
    key: "contentStyles",
    get: function get() {
      var styles = _objectSpread({}, this.themeStyles);

      var width = this.width,
          minWidth = this.minWidth,
          maxWidth = this.maxWidth;
      if (width !== undefined) styles.width = toStyleWidth(width);
      if (minWidth !== undefined) styles.minWidth = toStyleWidth(minWidth);
      if (maxWidth !== undefined) styles.maxWidth = toStyleWidth(maxWidth);
      return styles;
    }
  }]);

  return VStackDialog;
}(mixins(VStack$1, VStackTheme$1));

__decorate([Prop({
  type: String,
  default: 'v-stack-slide-y'
})], VStackDialog.prototype, "transition", void 0);

__decorate([Prop()], VStackDialog.prototype, "header", void 0);

__decorate([Prop({
  type: Array
})], VStackDialog.prototype, "actions", void 0);

__decorate([Prop({
  type: String,
  default: 'v-stack-dialog'
})], VStackDialog.prototype, "baseClassName", void 0);

__decorate([Prop({
  type: String
})], VStackDialog.prototype, "dialogType", void 0);

__decorate([Prop({
  type: [Number, String]
})], VStackDialog.prototype, "width", void 0);

__decorate([Prop({
  type: [Number, String]
})], VStackDialog.prototype, "minWidth", void 0);

__decorate([Prop({
  type: [Number, String]
})], VStackDialog.prototype, "maxWidth", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], VStackDialog.prototype, "focusTrap", void 0);

__decorate([Prop([String, Object])], VStackDialog.prototype, "prompt", void 0);

VStackDialog = __decorate([Component({
  name: 'v-stack-dialog',
  directives: {
    bodyScrollLock: bodyScrollLock
  }
})], VStackDialog);
var VStackDialog$1 = VStackDialog;

var VStackPanel =
/*#__PURE__*/
function (_Mixins) {
  _inherits(VStackPanel, _Mixins);

  function VStackPanel() {
    _classCallCheck(this, VStackPanel);

    return _possibleConstructorReturn(this, _getPrototypeOf(VStackPanel).apply(this, arguments));
  }

  _createClass(VStackPanel, [{
    key: "genStackPanelContent",
    value: function genStackPanelContent() {
      var defaultSlot = this.$scopedSlots.default;
      return this.$createElement('div', {
        staticClass: "".concat(this.baseClassName, "__content"),
        class: this.contentClasses,
        attrs: {
          tabindex: '0'
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
          }
        }
      }, defaultSlot && defaultSlot(this));
    }
  }, {
    key: "renderContent",
    value: function renderContent(h) {
      var _this = this;

      var baseClassName = this.baseClassName;
      var children = [];
      var $scroller = h('div', {
        staticClass: "".concat(baseClassName, "__scroller")
      }, [h('div', {
        staticClass: "".concat(baseClassName, "__centerer")
      }, [this.genStackPanelContent()])]);
      children.push($scroller);
      var panelChildren = [h('div', {
        staticClass: "".concat(baseClassName, "__inner"),
        directives: [{
          name: 'body-scroll-lock',
          value: this.isActive
        }]
      }, children)];

      if (this.$scopedSlots.controls) {
        panelChildren.push(h('div', {
          staticClass: "".concat(baseClassName, "__controls"),
          on: {
            click: function click(e) {
              e.stopPropagation();
            }
          }
        }, this.$scopedSlots.controls(this)));
      }

      return {
        tag: this.tag,
        data: {
          staticClass: baseClassName,
          class: this.panelClasses,
          on: {
            click: function click(e) {
              if (_this.closeOnClick && _this.closeConditional(e)) {
                _this.close();
              }
            }
          }
        },
        children: panelChildren
      };
    }
  }]);

  return VStackPanel;
}(mixins(VStack$1, VStackTheme$1));

__decorate([Prop({
  type: String,
  default: 'v-stack-panel'
})], VStackPanel.prototype, "baseClassName", void 0);

__decorate([Prop({
  type: String,
  default: 'div'
})], VStackPanel.prototype, "tag", void 0);

__decorate([Prop()], VStackPanel.prototype, "panelClasses", void 0);

__decorate([Prop()], VStackPanel.prototype, "contentClasses", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], VStackPanel.prototype, "focusTrap", void 0);

VStackPanel = __decorate([Component({
  name: 'v-stack-panel',
  directives: {
    bodyScrollLock: bodyScrollLock
  }
})], VStackPanel);
var VStackPanel$1 = VStackPanel;

var VStackTooltip =
/*#__PURE__*/
function (_Mixins) {
  _inherits(VStackTooltip, _Mixins);

  function VStackTooltip() {
    _classCallCheck(this, VStackTooltip);

    return _possibleConstructorReturn(this, _getPrototypeOf(VStackTooltip).apply(this, arguments));
  }

  _createClass(VStackTooltip, [{
    key: "renderContent",
    value: function renderContent(h) {
      var defaultSlot = this.$scopedSlots.default;
      return {
        tag: 'span',
        data: {
          staticClass: 'v-stack-tooltip',
          style: this.menuStyles
        },
        children: [h('span', {
          staticClass: 'v-stack-tooltip__body',
          style: _objectSpread({}, this.contextColorStyles, {
            opacity: this.opacity
          })
        }, defaultSlot && defaultSlot(this))]
      };
    }
  }, {
    key: "computedColor",
    get: function get() {
      return this.color || 'gray';
    }
  }]);

  return VStackTooltip;
}(mixins(VStackMenu$1, VStackThemeItem$1));

__decorate([Prop({
  type: [String, Number],
  default: 200
})], VStackTooltip.prototype, "openDelay", void 0);

__decorate([Prop({
  type: Boolean,
  default: true
})], VStackTooltip.prototype, "openOnHover", void 0);

__decorate([Prop({
  type: [String, Number],
  default: 0.9
})], VStackTooltip.prototype, "opacity", void 0);

VStackTooltip = __decorate([Component({
  name: 'v-stack-tooltip'
})], VStackTooltip);
var VStackTooltip$1 = VStackTooltip;

var addOnceEventListener = function addOnceEventListener(el, event, cb) {
  var once = function once(ev) {
    cb(ev);
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
};

var HORIZONTAL_MARGIN = 24;
var SAFE_TIMEOUT = 1000;

var getHeight = function getHeight(el) {
  var _el$getBoundingClient = el.getBoundingClientRect(),
      height = _el$getBoundingClient.height;

  if (height) return Promise.resolve(height);
  return new Promise(function (resolve) {
    var tick = function tick() {
      var _el$getBoundingClient2 = el.getBoundingClientRect(),
          height = _el$getBoundingClient2.height;

      if (height) {
        resolve(height);
      } else {
        Vue.nextTick(tick);
      }
    };

    tick();
  });
};

var VStackSnackbarTransition = {
  name: 'v-stack-snackbar-transition',
  functional: true,
  props: {
    position: {
      type: Object,
      required: true
    }
  },
  render: function render(h, _ref) {
    var props = _ref.props,
        children = _ref.children,
        listeners = _ref.listeners;
    var _props$position = props.position,
        top = _props$position.top,
        left = _props$position.left,
        right = _props$position.right;
    var hasHorizontal = left || right;
    var marginProp = top ? 'marginTop' : 'marginBottom';
    var safeTimer = null;

    var kickListener = function kickListener(event) {
      for (var _len = arguments.length, payload = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        payload[_key - 1] = arguments[_key];
      }

      var listener = listeners[event];

      if (listener) {
        var list = Array.isArray(listener) ? listener : [listener];
        list.forEach(function (f) {
          f.apply(void 0, payload);
        });
      }
    };

    var setOffset = function setOffset(el) {
      var disableTransition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return new Promise(function (resolve) {
        getHeight(el).then(function (height) {
          var offset = -height;
          if (hasHorizontal) offset -= HORIZONTAL_MARGIN;

          if (!disableTransition) {
            el.style[marginProp] = offset + 'px';
            return resolve();
          }

          el.style.transition = 'none';
          el.style[marginProp] = offset + 'px';
          setTimeout(function () {
            el.style.transition = '';
            setTimeout(resolve, 0);
          }, 0);
        });
      });
    };

    var removeOffset = function removeOffset(el) {
      var disableTransition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!disableTransition) {
        el.style[marginProp] = '';
        return Promise.resolve();
      }

      return new Promise(function (resolve) {
        el.style.transition = 'none';
        el.style[marginProp] = '';
        setTimeout(function () {
          el.style.transition = '';
          setTimeout(resolve, 0);
        }, 0);
      });
    };

    var clearSafeTimer = function clearSafeTimer() {
      if (safeTimer !== null) {
        clearTimeout(safeTimer);
        safeTimer = null;
      }
    };

    var data = {
      on: {
        beforeEnter: function beforeEnter(el) {
          kickListener('beforeEnter', el);
        },
        enter: function enter(el, done) {
          clearSafeTimer();
          safeTimer = window.setTimeout(function () {
            clearSafeTimer();
            done();
          }, SAFE_TIMEOUT);
          var beforeTimer = safeTimer;
          kickListener('enter', el, done);
          setOffset(el, true).then(function () {
            removeOffset(el);
            addOnceEventListener(el, 'transitionend', function (e) {
              if (beforeTimer !== safeTimer) return;
              var propertyName = e.propertyName;

              if (propertyName.indexOf('margin') === 0) {
                clearSafeTimer();
                done();
              }
            });
          });
        },
        afterEnter: function afterEnter(el) {
          removeOffset(el);
          clearSafeTimer();
          kickListener('afterEnter', el);
        },
        enterCancelled: function enterCancelled(el) {
          removeOffset(el);
          clearSafeTimer();
          kickListener('enterCancelled', el);
        },
        beforeLeave: function beforeLeave(el) {
          kickListener('beforeLeave', el);
        },
        leave: function leave(el, done) {
          clearSafeTimer();
          safeTimer = window.setTimeout(function () {
            clearSafeTimer();
            done();
          }, SAFE_TIMEOUT);
          var beforeTimer = safeTimer;
          kickListener('leave', el, done);
          setOffset(el).then(function () {
            addOnceEventListener(el, 'transitionend', function (e) {
              if (beforeTimer !== safeTimer) return;
              var propertyName = e.propertyName;

              if (propertyName.indexOf('margin') === 0) {
                removeOffset(el, true);
                clearSafeTimer();
                done();
              }
            });
          });
        },
        afterLeave: function afterLeave(el) {
          clearSafeTimer();
          removeOffset(el);
          kickListener('afterLeave', el);
        },
        leaveCancelled: function leaveCancelled(el) {
          clearSafeTimer();
          removeOffset(el);
          kickListener('leaveCancelled', el);
        }
      }
    };
    return h('transition', data, children);
  }
};

var VStackSnackbar =
/*#__PURE__*/
function (_Mixins) {
  _inherits(VStackSnackbar, _Mixins);

  function VStackSnackbar() {
    _classCallCheck(this, VStackSnackbar);

    return _possibleConstructorReturn(this, _getPrototypeOf(VStackSnackbar).apply(this, arguments));
  }

  _createClass(VStackSnackbar, [{
    key: "renderContent",
    value: function renderContent(h) {
      var _this = this;

      var children = [];
      var $scopedSlots = this.$scopedSlots,
          computedCloseBtn = this.computedCloseBtn;
      var defaultSlot = $scopedSlots.default,
          closeSlot = $scopedSlots.close;
      var $body = h('div', {
        staticClass: 'v-stack-snackbar__body'
      }, defaultSlot ? defaultSlot(this) : undefined);
      children.push($body);

      if (computedCloseBtn || closeSlot) {
        var $close;

        if (closeSlot) {
          $close = closeSlot(this);
        } else {
          if (typeof computedCloseBtn === 'string') {
            $close = [h(VStackBtn$1, {
              staticClass: 'v-stack-snackbar__close',
              attrs: {
                autofocus: true
              },
              props: {
                type: 'button',
                flat: true,
                color: 'accent'
              },
              on: {
                click: function click(e) {
                  _this.close();
                }
              }
            }, computedCloseBtn)];
          } else {
            $close = computedCloseBtn;
          }
        }

        var $actions = h('div', {
          staticClass: 'v-stack-snackbar__actions'
        }, $close);
        children.push($actions);
      }

      return {
        tag: 'div',
        data: {
          staticClass: 'v-stack-snackbar',
          class: this.snackClasses,
          style: this.snackStyles
        },
        children: [h('div', {
          staticClass: 'v-stack-snackbar__inner'
        }, children)]
      };
    }
  }, {
    key: "computedColor",
    get: function get() {
      return this.color || this.$vstackSettings.snackbar.color || 'dark';
    }
  }, {
    key: "snackStyles",
    get: function get() {
      var contextColor = this.contextColor;
      return {
        backgroundColor: contextColor.base,
        color: contextColor.text
      };
    }
  }, {
    key: "computedTransition",
    get: function get() {
      /**
       * @todo
       *   any
       */
      return VStackSnackbarTransition;
    }
  }, {
    key: "computedPosition",
    get: function get() {
      var top = this.top,
          bottom = this.bottom,
          left = this.left,
          right = this.right;

      if (top === bottom) {
        top = false;
        bottom = true;
      }

      if (left && right) {
        left = false;
      }

      return {
        top: top,
        bottom: bottom,
        left: left,
        right: right
      };
    }
  }, {
    key: "transitionProps",
    get: function get() {
      return {
        position: this.computedPosition
      };
    }
  }, {
    key: "computedCloseBtn",
    get: function get() {
      var closeBtn = this.closeBtn;
      if (closeBtn === false || closeBtn === null) return false;
      if (closeBtn === true || closeBtn === undefined) return this.$vstack.getString('close');
      return closeBtn;
    }
  }, {
    key: "hasHorizontal",
    get: function get() {
      var _this$computedPositio = this.computedPosition,
          left = _this$computedPositio.left,
          right = _this$computedPositio.right;
      return left || right;
    }
  }, {
    key: "snackClasses",
    get: function get() {
      var _this$computedPositio2 = this.computedPosition,
          left = _this$computedPositio2.left,
          right = _this$computedPositio2.right,
          top = _this$computedPositio2.top,
          bottom = _this$computedPositio2.bottom;
      return {
        'v-stack-snackbar--top': top,
        'v-stack-snackbar--bottom': bottom,
        'v-stack-snackbar--left': left,
        'v-stack-snackbar--right': right,
        'v-stack-snackbar--x-center': !left && !right,
        'v-stack-snackbar--has-horizontal': this.hasHorizontal
      };
    }
  }]);

  return VStackSnackbar;
}(mixins(VStack$1, VStackThemeItem$1));

__decorate([Prop({
  type: Boolean
})], VStackSnackbar.prototype, "top", void 0);

__decorate([Prop({
  type: Boolean
})], VStackSnackbar.prototype, "bottom", void 0);

__decorate([Prop({
  type: Boolean
})], VStackSnackbar.prototype, "left", void 0);

__decorate([Prop({
  type: Boolean
})], VStackSnackbar.prototype, "right", void 0);

__decorate([Prop()], VStackSnackbar.prototype, "closeBtn", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], VStackSnackbar.prototype, "closeOnClick", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], VStackSnackbar.prototype, "closeOnEsc", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], VStackSnackbar.prototype, "closeOnNavigation", void 0);

__decorate([Prop({
  type: [String, Number],
  default: 6000
})], VStackSnackbar.prototype, "timeout", void 0);

VStackSnackbar = __decorate([Component({
  name: 'v-stack-snackbar'
})], VStackSnackbar);
var VStackSnackbar$1 = VStackSnackbar;

var plugin = {
  installed: false,
  install: function install(Vue, opts) {
    if (this.installed) return;
    Vue.prototype.$vstackSettings = vueStackThemeSettingsDefaults(opts);
    this.installed = true;
  }
};

export default plugin;
export { BODY_SCROLL_LOCK_SCROLL_ATTRIBUTE, CLICKABLE_TAGS, VStack$1 as VStack, VStackBtn$1 as VStackBtn, VStackContainer$1 as VStackContainer, VStackContext$1 as VStackContext, VStackDialog$1 as VStackDialog, VStackDynamicContainer$1 as VStackDynamicContainer, VStackMenu$1 as VStackMenu, VStackPanel$1 as VStackPanel, VStackSnackbar$1 as VStackSnackbar, VStackTheme$1 as VStackTheme, VStackThemeItem$1 as VStackThemeItem, VStackTooltip$1 as VStackTooltip, bodyScrollLock, clickOutside, getElementByActivateSource, resoveRawVStackDialogPromptSettings, vueStackThemeNames, vueStackThemeSettingsDefaults };
